var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashPaymentPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 540.55,
    height: 425.95,
    viewBox: "0 0 662.55 425.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cash_Payment-pana",
    "data-name": "Cash Payment-pana",
    transform: "translate(-52.85 -36.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_232",
    "data-name": "Trazado 232",
    d: "M335.25,177.26c0,.2-3.07.36-6.87.36s-6.88-.16-6.88-.36,3.08-.36,6.88-.36S335.25,177.06,335.25,177.26Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_236",
    "data-name": "Trazado 236",
    d: "M299.48,177.26c0,.2-3.08.36-6.88.36s-6.87-.16-6.87-.36,3.07-.36,6.87-.36S299.48,177.06,299.48,177.26Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_240",
    "data-name": "Trazado 240",
    d: "M263.7,177.26c0,.2-3.08.36-6.87.36s-6.88-.16-6.88-.36,3.08-.36,6.88-.36S263.7,177.06,263.7,177.26Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_248",
    "data-name": "Trazado 248",
    d: "M192.15,177.26c0,.2-3.08.36-6.88.36s-6.87-.16-6.87-.36,3.08-.36,6.87-.36S192.15,177.06,192.15,177.26Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9038",
    "data-name": "Rect\\xE1ngulo 9038",
    width: 236.75,
    height: 11.55,
    transform: "translate(127.65 246.09)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_250",
    "data-name": "Trazado 250",
    d: "M59.32,413.71l7.44,48.88h43.21L120,414.42Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_251",
    "data-name": "Trazado 251",
    d: "M114,445c0,.14-11.07.25-24.73.25S64.5,445.18,64.5,445s11.07-.26,24.73-.26S114,444.9,114,445Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_252",
    "data-name": "Trazado 252",
    d: "M114.13,442.63c0,.14-11.15.26-24.9.26s-24.9-.12-24.9-.26,11.15-.25,24.9-.25S114.13,442.49,114.13,442.63Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_253",
    "data-name": "Trazado 253",
    d: "M114,439.92c0,.14-11.14.25-24.89.25s-24.9-.11-24.9-.25,11.14-.25,24.9-.25S114,439.78,114,439.92Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_254",
    "data-name": "Trazado 254",
    d: "M71.72,459.8a39.933,39.933,0,0,1-1.32-6.15,41.511,41.511,0,0,1-.83-6.24,37.89,37.89,0,0,1,1.33,6.15,39.069,39.069,0,0,1,.82,6.24Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_255",
    "data-name": "Trazado 255",
    d: "M74.66,459.28a49.61,49.61,0,0,1-.53-6,46.558,46.558,0,0,1-.28-6,29.27,29.27,0,0,1,.78,6,28.61,28.61,0,0,1,.03,6Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_256",
    "data-name": "Trazado 256",
    d: "M80,459.28a30.751,30.751,0,0,1-1.12-6.16,29.461,29.461,0,0,1-.33-6.25,54.489,54.489,0,0,1,.83,6.2,54,54,0,0,1,.62,6.21Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_257",
    "data-name": "Trazado 257",
    d: "M83.78,459.54a32.06,32.06,0,0,1-.6-6.26,30.389,30.389,0,0,1,.2-6.28,54.32,54.32,0,0,1,.31,6.27,51.739,51.739,0,0,1,.09,6.27Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_258",
    "data-name": "Trazado 258",
    d: "M90.44,459.28a35.121,35.121,0,0,1-.45-5.93,35.479,35.479,0,0,1,.05-6,70.88,70.88,0,0,1,.4,11.89Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_259",
    "data-name": "Trazado 259",
    d: "M95.3,459.54a37.3,37.3,0,0,1-.2-6.14,38,38,0,0,1,.3-6.14,36.59,36.59,0,0,1,.21,6.14,37.309,37.309,0,0,1-.31,6.14Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_260",
    "data-name": "Trazado 260",
    d: "M99.86,458.89a80.7,80.7,0,0,1,1.25-12.79,42.94,42.94,0,0,1-.37,6.42A41.46,41.46,0,0,1,99.86,458.89Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_261",
    "data-name": "Trazado 261",
    d: "M105.74,458.25a33.72,33.72,0,0,1,2.34-10.73A48.082,48.082,0,0,1,107,452.9a46.911,46.911,0,0,1-1.26,5.35Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_262",
    "data-name": "Trazado 262",
    d: "M101.58,317.26a.84.84,0,0,1,0,.24,3.289,3.289,0,0,1-.2.69c-.2.64-.48,1.53-.82,2.64s-.82,2.54-1.27,4.18-1,3.49-1.56,5.57-1.14,4.35-1.69,6.81-1.1,5.1-1.66,7.87c-1,5.58-2,11.74-2.65,18.24s-.92,12.75-1,18.41c0,2.84,0,5.53.08,8s.18,4.86.3,7,.3,4.08.43,5.78.28,3.15.42,4.35.21,2.07.28,2.74a3.54,3.54,0,0,0,.06.72,1.18,1.18,0,0,1,0,.25.81.81,0,0,1-.06-.24,4.787,4.787,0,0,0-.11-.71c-.09-.67-.22-1.58-.38-2.74s-.35-2.65-.5-4.35-.39-3.63-.5-5.77-.31-4.49-.37-7-.11-5.22-.13-8.06c.06-5.68.34-11.93,1-18.46s1.63-12.69,2.69-18.27c.58-2.79,1.1-5.43,1.72-7.88s1.17-4.74,1.74-6.81,1.14-3.93,1.64-5.56,1-3,1.35-4.16.69-2,.91-2.61c.1-.27.18-.5.25-.68A.9.9,0,0,1,101.58,317.26Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_263",
    "data-name": "Trazado 263",
    d: "M93.78,347.53A16.11,16.11,0,0,1,100.5,339c1.07-.66,2.42-1.2,3.55-.65,1.51.73,1.63,2.85,1.18,4.46a11.8,11.8,0,0,1-4.89,6.67A10,10,0,0,1,93,351.37",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_264",
    "data-name": "Trazado 264",
    d: "M91.16,368c1.11-4.21,4.48-10.21,8-12.82a5.089,5.089,0,0,1,1.82-1,2.11,2.11,0,0,1,1.94.42,3,3,0,0,1,.43,2.8,17,17,0,0,1-12.61,12.69",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_265",
    "data-name": "Trazado 265",
    d: "M90.43,386a24.65,24.65,0,0,1,8-10.11,3.84,3.84,0,0,1,2.81-1c1.53.28,2.22,2.15,2.08,3.69-.27,3.18-2.7,5.73-5.21,7.71a32.358,32.358,0,0,1-7.45,3.83",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_266",
    "data-name": "Trazado 266",
    d: "M90.84,398.89a23.7,23.7,0,0,1,6.85-7.8,4.94,4.94,0,0,1,2-.92,2.11,2.11,0,0,1,2,.77c.68,1,0,2.37-.71,3.34a19.5,19.5,0,0,1-9.77,7.17",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_267",
    "data-name": "Trazado 267",
    d: "M90.5,393.63a76.848,76.848,0,0,0-9.79-10c-.56-.47-1.26-1-1.95-.74a1.47,1.47,0,0,0-.9,1.32,3.73,3.73,0,0,0,.37,1.63,19,19,0,0,0,12.61,10.61",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_268",
    "data-name": "Trazado 268",
    d: "M90.81,376.8l-7.69-9.37a9.19,9.19,0,0,0-2.49-2.37,3.17,3.17,0,0,0-3.28,0,3.11,3.11,0,0,0-1.06,3.1,8.34,8.34,0,0,0,1.5,3.08,22.88,22.88,0,0,0,5.61,5.95c2.26,1.56,4.31,2.57,7,2.17",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_269",
    "data-name": "Trazado 269",
    d: "M91.88,357.86a26.73,26.73,0,0,0-7.74-11.62,4.49,4.49,0,0,0-2-1.18c-1.55-.3-3,1-3.53,2.48a6.36,6.36,0,0,0,.7,5.09,13.3,13.3,0,0,0,3.62,3.82,30.65,30.65,0,0,0,8.55,4.62",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_270",
    "data-name": "Trazado 270",
    d: "M95,341c-.75-5.43-3.58-10-6.86-14.36-.69-.92-1.65-1.91-2.8-1.73a2.22,2.22,0,0,0-1.6,1.38,5.12,5.12,0,0,0-.31,2.17,16.8,16.8,0,0,0,10.9,15",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_271",
    "data-name": "Trazado 271",
    d: "M97.11,332.34a44.659,44.659,0,0,1-.28-8.41,15.11,15.11,0,0,1,2.79-7.83,6.44,6.44,0,0,1,2.79-2.22,3.53,3.53,0,0,1,3.43.45,3.74,3.74,0,0,1,1.17,3,9.41,9.41,0,0,1-.87,3.22c-2,4.93-5.46,10.39-9,11.77",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_272",
    "data-name": "Trazado 272",
    d: "M63.6,338.81a3.38,3.38,0,0,1,0,.69q0,.75,0,2v3.12a40.664,40.664,0,0,0,.15,4.12c.14,3.06.43,6.7.9,10.71s1.18,8.41,2.12,13,2.12,8.87,3.27,12.75,2.38,7.31,3.49,10.17c.52,1.44,1.07,2.71,1.52,3.84s.86,2.09,1.21,2.87.57,1.36.77,1.82a3.379,3.379,0,0,1,.24.65,3.361,3.361,0,0,1-.33-.61c-.22-.45-.51-1-.86-1.78s-.82-1.72-1.29-2.84-1.05-2.39-1.6-3.82c-1.15-2.85-2.38-6.29-3.59-10.16s-2.35-8.2-3.32-12.78-1.62-9-2.1-13-.7-7.68-.79-10.75c-.07-1.53-.06-2.92-.07-4.14s0-2.27,0-3.13.05-1.47.07-2a3.15,3.15,0,0,1,.21-.73Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_273",
    "data-name": "Trazado 273",
    d: "M64.81,361.1a11.45,11.45,0,0,1,2.74-7.22,2.73,2.73,0,0,1,2.28-1.21c1.19.17,1.73,1.59,1.77,2.78A8.41,8.41,0,0,1,69.7,361a7.09,7.09,0,0,1-4.6,2.84",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_274",
    "data-name": "Trazado 274",
    d: "M67.42,375.58c-.15-3.11.85-7.92,2.67-10.45a3.65,3.65,0,0,1,1-1.05,1.51,1.51,0,0,1,1.41-.13,2.09,2.09,0,0,1,.9,1.81,12.13,12.13,0,0,1-5.85,11.36",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_275",
    "data-name": "Trazado 275",
    d: "M70.8,388a17.63,17.63,0,0,1,3.3-8.62,2.72,2.72,0,0,1,1.69-1.28c1.1-.14,2,1,2.22,2.06.49,2.22-.61,4.48-1.9,6.37a23.2,23.2,0,0,1-4.24,4.21",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_276",
    "data-name": "Trazado 276",
    d: "M73.86,396.7a16.9,16.9,0,0,1,3-6.78,3.51,3.51,0,0,1,1.2-1.07,1.49,1.49,0,0,1,1.54.09c.68.54.53,1.61.24,2.43a14,14,0,0,1-5.11,7",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_277",
    "data-name": "Trazado 277",
    d: "M72.5,393.2a54.381,54.381,0,0,0-8.82-4.69,1.57,1.57,0,0,0-1.48-.08,1,1,0,0,0-.33,1.09,2.5,2.5,0,0,0,.6,1,13.56,13.56,0,0,0,10.87,4.51",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_278",
    "data-name": "Trazado 278",
    d: "M69.09,381.67l-7.26-4.73a6.47,6.47,0,0,0-2.21-1.07,2.24,2.24,0,0,0-2.24.68,2.2,2.2,0,0,0-.05,2.33A5.81,5.81,0,0,0,59,380.66a16.42,16.42,0,0,0,5.1,2.84,6.824,6.824,0,0,0,5.25,0",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_279",
    "data-name": "Trazado 279",
    d: "M65.74,368.54A19.09,19.09,0,0,0,58,362.3a3.15,3.15,0,0,0-1.63-.37,2.42,2.42,0,0,0-1.87,2.45,4.56,4.56,0,0,0,1.5,3.31,9.67,9.67,0,0,0,3.29,1.83,22.34,22.34,0,0,0,6.82,1.3",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    "data-name": "Trazado 280",
    d: "M64.19,356.38c-1.68-3.54-4.58-6-7.75-8.3a2.32,2.32,0,0,0-2.28-.58,1.56,1.56,0,0,0-.8,1.28,3.75,3.75,0,0,0,.26,1.55,12,12,0,0,0,10.65,7.86",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    "data-name": "Trazado 281",
    d: "M63.8,350a32.541,32.541,0,0,1-2-5.66,10.67,10.67,0,0,1,.22-5.93,4.54,4.54,0,0,1,1.42-2.12,2.53,2.53,0,0,1,2.43-.43,2.7,2.7,0,0,1,1.45,1.8,6.79,6.79,0,0,1,.1,2.38c-.33,3.8-1.49,8.25-3.62,10",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    d: "M118.24,338.34a6.4,6.4,0,0,1,.06.69c0,.5,0,1.15.07,2a24.948,24.948,0,0,1,0,3.13c-.06,1.22,0,2.6-.08,4.13-.09,3.07-.35,6.72-.79,10.75s-1.14,8.45-2.09,13-2.13,8.89-3.32,12.77-2.44,7.32-3.6,10.16c-.54,1.44-1.11,2.7-1.59,3.82s-.92,2.08-1.29,2.85l-.86,1.78a3.81,3.81,0,0,1-.33.6,2.68,2.68,0,0,1,.24-.65c.19-.46.45-1.06.77-1.81s.76-1.75,1.21-2.88,1-2.4,1.52-3.84c1.11-2.85,2.29-6.3,3.48-10.16s2.3-8.18,3.27-12.75,1.63-9,2.13-13,.76-7.65.89-10.71c.1-1.53.11-2.91.15-4.13s0-2.26,0-3.12v-2A2.879,2.879,0,0,1,118.24,338.34Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    "data-name": "Trazado 283",
    d: "M117,360.63a11.43,11.43,0,0,0-2.75-7.23,2.74,2.74,0,0,0-2.28-1.21c-1.18.17-1.72,1.59-1.76,2.79a8.43,8.43,0,0,0,1.9,5.59,7.11,7.11,0,0,0,4.59,2.84",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_284",
    "data-name": "Trazado 284",
    d: "M114.42,375.1c.15-3.11-.85-7.92-2.67-10.45a3.65,3.65,0,0,0-1-1,1.51,1.51,0,0,0-1.41-.14,2.16,2.16,0,0,0-.9,1.82,12.16,12.16,0,0,0,5.86,11.35",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_285",
    "data-name": "Trazado 285",
    d: "M111,387.51a17.63,17.63,0,0,0-3.3-8.62,2.73,2.73,0,0,0-1.7-1.29c-1.1-.14-2,1-2.21,2.06-.5,2.23.61,4.49,1.89,6.38a22.93,22.93,0,0,0,4.25,4.2",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_286",
    "data-name": "Trazado 286",
    d: "M108,396.23a17,17,0,0,0-3-6.78,3.54,3.54,0,0,0-1.21-1.07,1.5,1.5,0,0,0-1.53.08c-.69.54-.53,1.61-.24,2.43a13.91,13.91,0,0,0,5.11,7",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_287",
    "data-name": "Trazado 287",
    d: "M109.34,392.72a55.451,55.451,0,0,1,8.81-4.68,1.56,1.56,0,0,1,1.49-.08,1,1,0,0,1,.33,1.09,2.71,2.71,0,0,1-.61,1,13.57,13.57,0,0,1-10.86,4.51",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_288",
    "data-name": "Trazado 288",
    d: "M112.75,381.2l7.26-4.73a6.729,6.729,0,0,1,2.2-1.08,2.29,2.29,0,0,1,2.25.68,2.24,2.24,0,0,1,.05,2.34,5.94,5.94,0,0,1-1.69,1.77,16.14,16.14,0,0,1-5.1,2.85c-1.87.57-3.48.82-5.24,0",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_289",
    "data-name": "Trazado 289",
    d: "M116.1,368.07a19.191,19.191,0,0,1,7.77-6.25,3.36,3.36,0,0,1,1.63-.37,2.43,2.43,0,0,1,1.87,2.45,4.57,4.57,0,0,1-1.58,3.32,9.691,9.691,0,0,1-3.28,1.82,22.1,22.1,0,0,1-6.82,1.3",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_290",
    "data-name": "Trazado 290",
    d: "M117.64,355.9c1.68-3.54,4.58-6,7.76-8.3a2.37,2.37,0,0,1,2.28-.58,1.6,1.6,0,0,1,.8,1.29,3.73,3.73,0,0,1-.26,1.54,12,12,0,0,1-10.65,7.87",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_291",
    "data-name": "Trazado 291",
    d: "M118,349.57a32.93,32.93,0,0,0,2-5.67,10.77,10.77,0,0,0-.22-5.93,4.53,4.53,0,0,0-1.42-2.11,2.5,2.5,0,0,0-2.43-.43,2.65,2.65,0,0,0-1.45,1.8,6.78,6.78,0,0,0-.1,2.38c.33,3.8,1.48,8.25,3.62,10",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_292",
    "data-name": "Trazado 292",
    d: "M54.36,404v9.15a3.6,3.6,0,0,0,3.6,3.6h62.58a3.6,3.6,0,0,0,3.6-3.6V404Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_293",
    "data-name": "Trazado 293",
    d: "M59.79,416.78l.52,2.91,57.74,4.12,1.46-7.03Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_297",
    "data-name": "Trazado 297",
    d: "M185.53,99.93c-.11,0-.29-.37-.41-.88s-.13-.94,0-1,.28.37.4.88S185.63,99.91,185.53,99.93Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_302",
    "data-name": "Trazado 302",
    d: "M243.23,99.93c-.11,0-.29-.37-.4-.88s-.13-.94,0-1,.29.37.4.88S243.33,99.91,243.23,99.93Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_307",
    "data-name": "Trazado 307",
    d: "M156.06,99.93c-.11,0-.29-.37-.41-.88s-.13-.94,0-1,.28.37.4.88S156.16,99.91,156.06,99.93Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_312",
    "data-name": "Trazado 312",
    d: "M213.53,99.93c-.1,0-.28-.37-.4-.88s-.13-.94,0-1,.28.37.4.88S213.64,99.91,213.53,99.93Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_317",
    "data-name": "Trazado 317",
    d: "M304.27,99.93c-.1,0-.28-.37-.4-.88s-.13-.94,0-1,.28.37.4.88S304.38,99.91,304.27,99.93Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_322",
    "data-name": "Trazado 322",
    d: "M274.58,99.93c-.11,0-.29-.37-.41-.88s-.12-.94,0-1,.28.37.4.88S274.68,99.91,274.58,99.93Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9039",
    "data-name": "Rect\\xE1ngulo 9039",
    width: 236.75,
    height: 11.55,
    transform: "translate(111.12 112.09)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_324",
    "data-name": "Trazado 324",
    d: "M201.46,319.49A10.94,10.94,0,0,0,192.24,307a1.1,1.1,0,0,0-.78.09,1.13,1.13,0,0,0-.29,1.06,13.19,13.19,0,0,0,10.27,11.65",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_325",
    "data-name": "Trazado 325",
    d: "M186.14,339.67c2.75,5.68,6.72,9.51,11.63,9.7,1,0,1.72-.61,2.66-.67a5.868,5.868,0,0,1,1.57.59,2.2,2.2,0,0,0,.82.19c5.07-.27,9.4-3.84,12.31-9.81,4.06-8.36,2.8-17.34-2.79-20.07a13.62,13.62,0,0,0-2.3-.9,9.139,9.139,0,0,0-2.78-.32,20.63,20.63,0,0,0-6.36,1.44,2.148,2.148,0,0,0-.27.1c-4.55-2-8.19-2-11.71-.32C183.32,322.33,182.08,331.31,186.14,339.67Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_326",
    "data-name": "Trazado 326",
    d: "M186.23,331.2a4.41,4.41,0,0,1-.46-1.68,9.07,9.07,0,0,1,2.84-7.69,4.539,4.539,0,0,1,1.44-1c0,.06-.52.42-1.25,1.17a9.811,9.811,0,0,0-2.76,7.44C186.11,330.54,186.3,331.18,186.23,331.2Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_327",
    "data-name": "Trazado 327",
    d: "M187.26,335.17c-.1,0-.28-.37-.4-.88s-.13-.94,0-1,.28.37.4.89S187.37,335.15,187.26,335.17Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_328",
    "data-name": "Trazado 328",
    d: "M213,305.81c0,.07-1.05.48-2.63,1.42a21.256,21.256,0,0,0-7.62,7.94,20.831,20.831,0,0,0-1.31,2.94c-.61,1.73-.8,2.87-.87,2.85a3.181,3.181,0,0,1,.09-.8,7.448,7.448,0,0,1,.18-.93c.1-.36.18-.77.34-1.21a18.159,18.159,0,0,1,1.26-3,21,21,0,0,1,2.21-3.35,21.637,21.637,0,0,1,2.84-2.83,20.545,20.545,0,0,1,2.71-1.83c.4-.24.79-.4,1.12-.56a5.808,5.808,0,0,1,.88-.37,3.78,3.78,0,0,1,.8-.27Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_331",
    "data-name": "Trazado 331",
    d: "M243.94,331.2a4.29,4.29,0,0,1-.47-1.68,9.07,9.07,0,0,1,2.84-7.69,4.39,4.39,0,0,1,1.45-1c0,.06-.52.42-1.26,1.17a10,10,0,0,0-2.16,3.44,10.12,10.12,0,0,0-.6,4C243.81,330.54,244,331.18,243.94,331.2Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_332",
    "data-name": "Trazado 332",
    d: "M245,335.17c-.11,0-.29-.37-.41-.88s-.13-.94,0-1,.28.37.4.89A1.557,1.557,0,0,1,245,335.17Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_334",
    "data-name": "Trazado 334",
    d: "M172,319.49A10.94,10.94,0,0,0,162.77,307a1.1,1.1,0,0,0-.78.09,1.13,1.13,0,0,0-.29,1.06A13.19,13.19,0,0,0,172,319.8",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_335",
    "data-name": "Trazado 335",
    d: "M156.66,339.67c2.76,5.68,6.73,9.51,11.64,9.7,1,0,1.72-.61,2.66-.67a5.868,5.868,0,0,1,1.57.59,2.2,2.2,0,0,0,.82.19c5.07-.27,9.4-3.84,12.31-9.81,4.06-8.36,2.8-17.34-2.79-20.07a13.617,13.617,0,0,0-2.3-.9,9.14,9.14,0,0,0-2.78-.32,20.63,20.63,0,0,0-6.36,1.44,2.144,2.144,0,0,0-.27.1c-4.55-2-8.19-2-11.71-.32C153.85,322.33,152.6,331.31,156.66,339.67Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_336",
    "data-name": "Trazado 336",
    d: "M156.76,331.2a4.41,4.41,0,0,1-.46-1.68,9.07,9.07,0,0,1,2.84-7.69,4.539,4.539,0,0,1,1.44-1c0,.06-.52.42-1.25,1.17a9.811,9.811,0,0,0-2.76,7.44C156.64,330.54,156.83,331.18,156.76,331.2Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_337",
    "data-name": "Trazado 337",
    d: "M157.79,335.17c-.1,0-.28-.37-.4-.88s-.13-.94,0-1,.29.37.41.89S157.9,335.15,157.79,335.17Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_338",
    "data-name": "Trazado 338",
    d: "M183.56,305.81c0,.07-1.05.48-2.63,1.42a21.255,21.255,0,0,0-7.62,7.94,20.832,20.832,0,0,0-1.31,2.94c-.61,1.73-.8,2.87-.87,2.85a3.18,3.18,0,0,1,.09-.8,7.448,7.448,0,0,1,.18-.93c.1-.36.18-.77.34-1.21a18.158,18.158,0,0,1,1.26-3,21,21,0,0,1,2.21-3.35,21.64,21.64,0,0,1,2.84-2.83,20.539,20.539,0,0,1,2.71-1.83c.4-.24.79-.4,1.12-.56a5.813,5.813,0,0,1,.88-.37,3.78,3.78,0,0,1,.8-.27Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_340",
    "data-name": "Trazado 340",
    d: "M214.14,339.67c2.76,5.68,6.73,9.51,11.64,9.7,1,0,1.72-.61,2.66-.67a6,6,0,0,1,1.57.59,2.16,2.16,0,0,0,.82.19c5.07-.27,9.39-3.84,12.31-9.81,4.06-8.36,2.8-17.34-2.8-20.07a13.533,13.533,0,0,0-2.29-.9,9.14,9.14,0,0,0-2.78-.32,20.57,20.57,0,0,0-6.36,1.44l-.28.1c-4.55-2-8.18-2-11.7-.32C211.33,322.33,210.08,331.31,214.14,339.67Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_341",
    "data-name": "Trazado 341",
    d: "M214.24,331.2a4.41,4.41,0,0,1-.46-1.68,9.07,9.07,0,0,1,2.84-7.69,4.54,4.54,0,0,1,1.44-1c0,.06-.52.42-1.25,1.17a9.82,9.82,0,0,0-2.76,7.46C214.12,330.54,214.31,331.18,214.24,331.2Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_342",
    "data-name": "Trazado 342",
    d: "M215.27,335.17c-.1,0-.28-.37-.4-.88s-.13-.94,0-1,.29.37.4.89S215.37,335.15,215.27,335.17Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_346",
    "data-name": "Trazado 346",
    d: "M305,331.2a4.41,4.41,0,0,1-.46-1.68,8.9,8.9,0,0,1,.5-4.18,9.08,9.08,0,0,1,2.33-3.51,4.5,4.5,0,0,1,1.45-1c0,.06-.52.42-1.25,1.17a9.82,9.82,0,0,0-2.76,7.46C304.86,330.54,305.05,331.18,305,331.2Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_347",
    "data-name": "Trazado 347",
    d: "M306,335.17c-.11,0-.29-.37-.4-.88s-.13-.94,0-1,.29.37.4.89S306.11,335.15,306,335.17Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_349",
    "data-name": "Trazado 349",
    d: "M290.51,319.49A10.94,10.94,0,0,0,281.29,307a1.1,1.1,0,0,0-.78.09,1.13,1.13,0,0,0-.29,1.06A13.18,13.18,0,0,0,290.5,319.8",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_351",
    "data-name": "Trazado 351",
    d: "M275.28,331.2a4.41,4.41,0,0,1-.46-1.68,9.07,9.07,0,0,1,2.84-7.69,4.39,4.39,0,0,1,1.45-1c0,.06-.52.42-1.26,1.17a9.811,9.811,0,0,0-2.76,7.44C275.16,330.54,275.35,331.18,275.28,331.2Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_352",
    "data-name": "Trazado 352",
    d: "M276.31,335.17c-.1,0-.28-.37-.4-.88s-.13-.94,0-1,.28.37.4.89S276.42,335.15,276.31,335.17Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_353",
    "data-name": "Trazado 353",
    d: "M302.08,305.81c0,.07-1.05.48-2.63,1.42a21.256,21.256,0,0,0-7.62,7.94,20.829,20.829,0,0,0-1.31,2.94c-.61,1.73-.79,2.87-.87,2.85a3.179,3.179,0,0,1,.09-.8,6.143,6.143,0,0,1,.19-.93,11.247,11.247,0,0,1,.33-1.21,19.052,19.052,0,0,1,1.26-3,21,21,0,0,1,2.21-3.35,21.638,21.638,0,0,1,2.84-2.83,20.537,20.537,0,0,1,2.71-1.83c.4-.24.79-.4,1.12-.56a5.807,5.807,0,0,1,.88-.37A3.779,3.779,0,0,1,302.08,305.81Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9040",
    "data-name": "Rect\\xE1ngulo 9040",
    width: 236.75,
    height: 11.55,
    transform: "translate(111.12 347.33)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9041",
    "data-name": "Rect\\xE1ngulo 9041",
    width: 153.35,
    height: 242.34,
    transform: "translate(516.76 58.71)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9042",
    "data-name": "Rect\\xE1ngulo 9042",
    width: 144.56,
    height: 233.8,
    transform: "translate(520.89 63.27)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9043",
    "data-name": "Rect\\xE1ngulo 9043",
    width: 57.64,
    height: 89.45,
    transform: "translate(593.17 76.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_354",
    "data-name": "Trazado 354",
    d: "M625.06,84.79a2.15,2.15,0,1,1-2.15-2.15,2.15,2.15,0,0,1,2.15,2.15Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9044",
    "data-name": "Rect\\xE1ngulo 9044",
    width: 57.64,
    height: 89.45,
    transform: "translate(535.08 191.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_355",
    "data-name": "Trazado 355",
    d: "M567,199.13a2.15,2.15,0,1,1-2.15-2.15,2.15,2.15,0,0,1,2.15,2.15Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9045",
    "data-name": "Rect\\xE1ngulo 9045",
    width: 49.23,
    height: 69.85,
    transform: "translate(534.3 76.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_356",
    "data-name": "Trazado 356",
    d: "M560.7,83.23a1.79,1.79,0,1,1-1.78-1.79,1.79,1.79,0,0,1,1.78,1.79Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9046",
    "data-name": "Rect\\xE1ngulo 9046",
    width: 52.98,
    height: 29.36,
    transform: "translate(600.072 198.349) rotate(-6.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_357",
    "data-name": "Trazado 357",
    d: "M628.84,201a1.83,1.83,0,1,1-1.83-1.83,1.83,1.83,0,0,1,1.83,1.83Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_358",
    "data-name": "Trazado 358",
    d: "M585,211.63c0,.23-9,.43-20.21.43s-20.22-.2-20.22-.43,9-.43,20.22-.43S585,211.39,585,211.63Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_359",
    "data-name": "Trazado 359",
    d: "M585,218c0,.23-9,.43-20.21.43s-20.22-.2-20.22-.43,9-.43,20.22-.43S585,217.79,585,218Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_360",
    "data-name": "Trazado 360",
    d: "M585,224.43c0,.23-9,.43-20.21.43s-20.22-.2-20.22-.43,9-.43,20.22-.43S585,224.19,585,224.43Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_361",
    "data-name": "Trazado 361",
    d: "M585,230.83c0,.23-9,.43-20.21.43s-20.22-.2-20.22-.43,9-.43,20.22-.43S585,230.59,585,230.83Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_362",
    "data-name": "Trazado 362",
    d: "M585,237.23c0,.23-9,.43-20.21.43s-20.22-.2-20.22-.43,9-.43,20.22-.43S585,237,585,237.23Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_363",
    "data-name": "Trazado 363",
    d: "M585,243.63c0,.23-9,.43-20.21.43s-20.22-.2-20.22-.43,9-.43,20.22-.43S585,243.39,585,243.63Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_364",
    "data-name": "Trazado 364",
    d: "M585,250c0,.23-9,.42-20.21.42s-20.22-.19-20.22-.42,9-.43,20.22-.43S585,249.79,585,250Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_365",
    "data-name": "Trazado 365",
    d: "M647.78,204.77c0,.24-8.9,1.69-20,3.25s-20,2.64-20.08,2.4,8.9-1.69,20-3.25S647.75,204.54,647.78,204.77Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_366",
    "data-name": "Trazado 366",
    d: "M648.58,208.77c0,.24-8.9,1.69-20,3.25s-20,2.64-20.08,2.4,8.9-1.69,20-3.25S648.55,208.54,648.58,208.77Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_367",
    "data-name": "Trazado 367",
    d: "M649.32,212.47c0,.24-8.91,1.69-20,3.25s-20.05,2.64-20.08,2.4,8.9-1.69,20-3.25S649.28,212.24,649.32,212.47Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_368",
    "data-name": "Trazado 368",
    d: "M645.75,95.6c0,.23-10.23.43-22.84.43s-22.84-.2-22.84-.43,10.23-.43,22.84-.43S645.75,95.36,645.75,95.6Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_369",
    "data-name": "Trazado 369",
    d: "M645.75,99.4c0,.24-10.23.43-22.84.43s-22.84-.19-22.84-.43,10.23-.4,22.84-.4S645.75,99.17,645.75,99.4Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_370",
    "data-name": "Trazado 370",
    d: "M645.75,103.21c0,.24-10.23.43-22.84.43s-22.84-.19-22.84-.43,10.23-.43,22.84-.43S645.75,103,645.75,103.21Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_371",
    "data-name": "Trazado 371",
    d: "M645.75,107c0,.24-10.23.43-22.84.43s-22.84-.19-22.84-.43,10.23-.43,22.84-.43S645.75,106.78,645.75,107Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_372",
    "data-name": "Trazado 372",
    d: "M645.75,110.82c0,.24-10.23.43-22.84.43s-22.84-.19-22.84-.43,10.23-.43,22.84-.43S645.75,110.58,645.75,110.82Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_373",
    "data-name": "Trazado 373",
    d: "M645.75,114.62c0,.24-10.23.43-22.84.43s-22.84-.19-22.84-.43,10.23-.43,22.84-.43S645.75,114.39,645.75,114.62Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_374",
    "data-name": "Trazado 374",
    d: "M645.75,118.43c0,.24-10.23.43-22.84.43s-22.84-.19-22.84-.43,10.23-.43,22.84-.43S645.75,118.19,645.75,118.43Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_375",
    "data-name": "Trazado 375",
    d: "M645.75,129.72c0,.24-10.23.43-22.84.43s-22.84-.19-22.84-.43,10.23-.43,22.84-.43S645.75,129.48,645.75,129.72Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_376",
    "data-name": "Trazado 376",
    d: "M646.07,133.74c0,.24-10.23.43-22.84.43s-22.84-.19-22.84-.43,10.23-.43,22.84-.43S646.07,133.5,646.07,133.74Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_377",
    "data-name": "Trazado 377",
    d: "M646.39,137.76c0,.24-10.22.43-22.84.43s-22.83-.19-22.83-.43,10.22-.43,22.83-.43S646.39,137.52,646.39,137.76Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_378",
    "data-name": "Trazado 378",
    d: "M646.71,141.78c0,.24-10.22.43-22.83.43S601,142,601,141.78s10.22-.43,22.84-.43S646.71,141.54,646.71,141.78Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_379",
    "data-name": "Trazado 379",
    d: "M647,145.8c0,.23-10.23.43-22.84.43s-22.84-.2-22.84-.43,10.22-.43,22.84-.43S647,145.56,647,145.8Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_380",
    "data-name": "Trazado 380",
    d: "M647.36,149.82c0,.23-10.23.43-22.84.43s-22.84-.2-22.84-.43,10.22-.43,22.84-.43S647.36,149.58,647.36,149.82Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_18",
    "data-name": "Elipse 18",
    cx: 43.65,
    cy: 43.65,
    r: 43.65,
    transform: "matrix(0.159, -0.987, 0.987, 0.159, 381.506, 123.09)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_19",
    "data-name": "Elipse 19",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    transform: "matrix(0.974, -0.226, 0.226, 0.974, 384.628, 56.934)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_381",
    "data-name": "Trazado 381",
    d: "M392.13,84.14v3.92c0,.51.1,1.07.14,1.68s.12,1.25.18,2a21.487,21.487,0,0,0,.38,2.19,38,38,0,0,0,3.69,10.82,39.6,39.6,0,0,0,9.31,11.86l1.63,1.39c.57.43,1.18.83,1.78,1.26a18.076,18.076,0,0,0,1.85,1.24l2,1.12,1,.56,1.07.47,2.17,1c.74.3,1.52.51,2.29.77a20,20,0,0,0,2.35.7,37.94,37.94,0,0,0,4.95.91c.85.08,1.7.22,2.57.26h3.94l1.33-.11c.89-.09,1.79-.14,2.68-.26a40.9,40.9,0,0,0,5.36-1.2l1.34-.39.68-.2.65-.27,2.63-1.06c.86-.4,1.69-.87,2.55-1.31.42-.23.87-.42,1.27-.69l1.22-.79a45.07,45.07,0,0,0,4.72-3.51l2.15-2.07.54-.53.49-.57,1-1.15,1-1.15.88-1.24.88-1.26.44-.63c.14-.22.26-.44.38-.66l1.53-2.7q.61-1.41,1.26-2.85a42.419,42.419,0,0,0,2.85-12.31A42.189,42.189,0,0,0,470,76.76l-.87-3c-.39-1-.78-1.91-1.16-2.87l-.29-.71-.36-.68-.7-1.36-.71-1.35-.83-1.27-.82-1.27-.42-.63-.47-.59-1.86-2.34a43.93,43.93,0,0,0-4.22-4.09l-1.11-1c-.36-.32-.78-.57-1.16-.85-.8-.54-1.56-1.12-2.36-1.63l-2.47-1.4-.61-.34c-.21-.11-.43-.19-.64-.29l-1.28-.57a42.142,42.142,0,0,0-5.16-1.89c-.87-.24-1.76-.4-2.63-.6l-1.3-.29c-.43-.09-.88-.11-1.31-.17l-2.6-.31c-.87-.07-1.73,0-2.58-.07a38,38,0,0,0-5,.25,19.831,19.831,0,0,0-2.43.39c-.79.16-1.59.27-2.36.47L420,49l-1.12.33-1.07.43-2.12.84c-.7.27-1.33.67-2,1s-1.3.66-1.93,1l-1.79,1.16a39.48,39.48,0,0,0-10.78,10.55,37.73,37.73,0,0,0-5.07,10.23,19.637,19.637,0,0,0-.66,2.13c-.16.68-.3,1.32-.43,1.91s-.28,1.14-.36,1.64-.12,1-.17,1.38l-.24,1.88c-.06.42-.1.64-.1.64a6.323,6.323,0,0,1,.05-.65c.05-.43.11-1.06.2-1.88a13.284,13.284,0,0,1,.15-1.39c.06-.51.22-1,.34-1.64s.26-1.24.41-1.93a22,22,0,0,1,.64-2.14,37.779,37.779,0,0,1,5-10.32A39.511,39.511,0,0,1,409.76,53.5l1.8-1.18c.63-.36,1.29-.68,1.94-1s1.31-.73,2-1l2.13-.86,1.08-.44,1.13-.33,2.29-.68c.78-.2,1.59-.31,2.39-.48a20,20,0,0,1,2.44-.39,38.749,38.749,0,0,1,5.08-.27c.86,0,1.73,0,2.6.07l2.63.3c.44.06.89.09,1.33.17l1.31.29c.88.21,1.78.37,2.66.61a42.3,42.3,0,0,1,5.21,1.9l1.29.57.65.29.62.35,2.5,1.41c.81.51,1.58,1.09,2.38,1.64.39.29.82.54,1.18.86l1.12,1a45.083,45.083,0,0,1,4.28,4.14c.62.79,1.25,1.57,1.88,2.36l.47.6.42.64.83,1.28.84,1.28.72,1.37.71,1.37.36.69.3.72,1.17,2.9c.3,1,.59,2,.89,3a42.429,42.429,0,0,1,1.23,12.71,42.42,42.42,0,0,1-2.89,12.45l-1.27,2.88L466,107.41c-.13.23-.25.46-.39.68l-.45.63-.89,1.27-.89,1.26-1,1.16-1,1.16-.5.58-.54.53-2.18,2.09a44.562,44.562,0,0,1-4.77,3.54l-1.24.8c-.41.27-.86.47-1.28.7-.87.44-1.71.92-2.58,1.32l-2.66,1.07-.66.26c-.22.08-.45.14-.68.21l-1.35.39a41.758,41.758,0,0,1-5.42,1.2c-.91.13-1.81.17-2.71.26l-1.34.11h-3.99a24.516,24.516,0,0,1-2.58-.28,36.8,36.8,0,0,1-5-.93,18.541,18.541,0,0,1-2.37-.71c-.78-.26-1.56-.48-2.31-.78l-2.18-1-1.08-.48-1-.57-2-1.14c-.66-.36-1.24-.84-1.86-1.25s-1.21-.84-1.79-1.28l-1.63-1.4a39.58,39.58,0,0,1-9.33-12,37.59,37.59,0,0,1-3.64-10.9,21.817,21.817,0,0,1-.36-2.2c-.05-.7-.11-1.36-.16-2s-.1-1.17-.12-1.68,0-1,0-1.4c0-.82,0-1.45.05-1.89A1.975,1.975,0,0,0,392.13,84.14Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_382",
    "data-name": "Trazado 382",
    d: "M450,87.59a8.609,8.609,0,0,1-1.4.09l-3.86.08c-3.28,0-7.85.08-13,.08h-.26V85c0-5.75,0-11,.08-14.74,0-1.81.06-3.32.08-4.46a9.291,9.291,0,0,1,.1-1.64,9.291,9.291,0,0,1,.1,1.64c0,1.14.05,2.65.08,4.46.05,3.78.08,9,.08,14.74v2.58l-.26-.26c5.15,0,9.72,0,13,.09l3.86.08A7.36,7.36,0,0,1,450,87.59Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_383",
    "data-name": "Trazado 383",
    d: "M431.88,53.16a11,11,0,0,1,.26,3.33,11.06,11.06,0,0,1-.26,3.34,11.06,11.06,0,0,1-.26-3.34A11,11,0,0,1,431.88,53.16Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_384",
    "data-name": "Trazado 384",
    d: "M450,58.52A10.83,10.83,0,0,1,447.84,61a10.479,10.479,0,0,1-2.51,2.14,10.831,10.831,0,0,1,2.15-2.51A10.7,10.7,0,0,1,450,58.52Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_385",
    "data-name": "Trazado 385",
    d: "M460.57,70.08a13.479,13.479,0,0,1-2.73,1.83A13.51,13.51,0,0,1,455,73.5a8.87,8.87,0,0,1,2.62-2A9,9,0,0,1,460.57,70.08Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_386",
    "data-name": "Trazado 386",
    d: "M466.78,87.24a40,40,0,0,1-9.11,0,41.62,41.62,0,0,1,9.11,0Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_387",
    "data-name": "Trazado 387",
    d: "M403.66,86.64a37.1,37.1,0,0,1-8.6,0,35.689,35.689,0,0,1,8.6,0Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_388",
    "data-name": "Trazado 388",
    d: "M408.13,99.41a19.13,19.13,0,0,1-3.25,3,19.461,19.461,0,0,1-3.57,2.55,18.359,18.359,0,0,1,3.24-3,19.359,19.359,0,0,1,3.58-2.55Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_389",
    "data-name": "Trazado 389",
    d: "M419.14,109.29a28.757,28.757,0,0,1-2.21,3.84,30.439,30.439,0,0,1-2.35,3.75,14.681,14.681,0,0,1,1.91-4,14.421,14.421,0,0,1,2.65-3.59Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_390",
    "data-name": "Trazado 390",
    d: "M431.88,122a20.41,20.41,0,0,1-.26-4.55,20.329,20.329,0,0,1,.26-4.55,20.332,20.332,0,0,1,.26,4.55,20.408,20.408,0,0,1-.26,4.55Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_391",
    "data-name": "Trazado 391",
    d: "M451.5,116a13,13,0,0,1-3.75-2.57,13.4,13.4,0,0,1-3.06-3.36,42.219,42.219,0,0,1,3.4,3A42.176,42.176,0,0,1,451.5,116Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_392",
    "data-name": "Trazado 392",
    d: "M460.71,106.06a15.93,15.93,0,0,1-3-2.65,16,16,0,0,1-2.66-3,15.811,15.811,0,0,1,3,2.65,16.149,16.149,0,0,1,2.66,3Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_393",
    "data-name": "Trazado 393",
    d: "M407.71,74.4a12.26,12.26,0,0,1-2.66-2.3,12.261,12.261,0,0,1-2.3-2.66,12.261,12.261,0,0,1,2.66,2.3,12.26,12.26,0,0,1,2.3,2.66Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_394",
    "data-name": "Trazado 394",
    d: "M419.07,62.43a11.579,11.579,0,0,1-2.61-2.24,11.7,11.7,0,0,1-2.26-2.61,11.58,11.58,0,0,1,2.62,2.24,11.8,11.8,0,0,1,2.25,2.61Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_395",
    "data-name": "Trazado 395",
    d: "M396.66,86.89a39.49,39.49,0,0,1,37.149-39.42c-.769,0-1.559-.08-2.349-.08a39.51,39.51,0,0,0,0,79,22.87,22.87,0,0,0,2.35-.08,39.5,39.5,0,0,1-37.15-39.42Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_396",
    "data-name": "Trazado 396",
    d: "M195.23,168.76a12.6,12.6,0,0,0-.91-21.93l-15.11-2.93q.6,28.42.82,56.86c3.86-.72,7.8-1.91,10.7-4.56s4.45-7.09,2.76-10.64a10,10,0,0,0,1.74-16.8Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_397",
    "data-name": "Trazado 397",
    d: "M122.84,167.28l-.34-6.72,40.15-8.93c12.41-1.71,26.26,10.36,27.44,22.83,1.3,13.86,2.35,30.83,1,41.24-2.66,20.93-18.55,24.08-18.55,24.08l1.29,20.56c.51,12-9.53,15-21.55,15.51h0a21.81,21.81,0,0,1-22.69-20.11Z",
    fill: "#c4947f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_398",
    "data-name": "Trazado 398",
    d: "M184.54,188.13a2.67,2.67,0,0,1-2.5,2.77,2.54,2.54,0,0,1-2.82-2.32,2.67,2.67,0,0,1,2.49-2.78,2.57,2.57,0,0,1,2.83,2.33Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_399",
    "data-name": "Trazado 399",
    d: "M186,183.44c-.32.36-2.39-1.07-5.27-1s-4.93,1.6-5.26,1.26c-.16-.15.16-.79,1.06-1.49a7.38,7.38,0,0,1,4.2-1.43,7,7,0,0,1,4.2,1.21C185.8,182.66,186.12,183.28,186,183.44Z",
    fill: "#263238",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_400",
    "data-name": "Trazado 400",
    d: "M157.78,189.87a2.67,2.67,0,0,1-2.49,2.77,2.55,2.55,0,0,1-2.83-2.32,2.67,2.67,0,0,1,2.49-2.78,2.57,2.57,0,0,1,2.83,2.33Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_401",
    "data-name": "Trazado 401",
    d: "M157.72,184.86c-.33.36-2.4-1.08-5.27-1s-4.94,1.6-5.26,1.26c-.16-.16.16-.79,1.06-1.49a7.27,7.27,0,0,1,4.19-1.44,7.07,7.07,0,0,1,4.21,1.21C157.55,184.08,157.87,184.7,157.72,184.86Z",
    fill: "#263238",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_402",
    "data-name": "Trazado 402",
    d: "M168.81,205.85c0-.16,1.76-.52,4.64-1,.73-.1,1.43-.27,1.53-.77a3.7,3.7,0,0,0-.55-2.16l-2.35-5.53c-3.26-7.86-5.65-14.34-5.33-14.47s3.22,6.14,6.48,14l2.26,5.56a4.27,4.27,0,0,1,.47,2.87,1.85,1.85,0,0,1-1.18,1.11,4.66,4.66,0,0,1-1.24.21C170.63,206,168.83,206,168.81,205.85Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_403",
    "data-name": "Trazado 403",
    d: "M172.56,239.83a55.14,55.14,0,0,1-28.84-6.6s7.49,14.37,29,11.8Z",
    fill: "#9e7066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_404",
    "data-name": "Trazado 404",
    d: "M167.81,212.82a5.19,5.19,0,0,0-4.7-1.78,4.73,4.73,0,0,0-3.22,1.85,3,3,0,0,0-.12,3.44,3.5,3.5,0,0,0,3.8.83,11,11,0,0,0,3.61-2.3A3.15,3.15,0,0,0,168,214a1,1,0,0,0,0-1.07",
    fill: "#9e7066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_405",
    "data-name": "Trazado 405",
    d: "M160.41,208.11c.47-.05.57,3.07,3.31,5.21s6.05,1.68,6.09,2.12c.05.19-.72.63-2.13.71a7.73,7.73,0,0,1-5.07-1.6,6.77,6.77,0,0,1-2.58-4.37C159.87,208.88,160.2,208.09,160.41,208.11Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_406",
    "data-name": "Trazado 406",
    d: "M158.11,176.72c-.26.79-3.14.51-6.5,1s-6.06,1.51-6.53.83c-.21-.33.24-1.08,1.32-1.87a11.43,11.43,0,0,1,9.92-1.41C157.58,175.75,158.22,176.34,158.11,176.72Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_407",
    "data-name": "Trazado 407",
    d: "M185.56,173.59c-.48.67-2.48,0-4.87.09s-4.38.58-4.87-.09c-.21-.33.09-1,1-1.64a7.07,7.07,0,0,1,7.85,0C185.48,172.6,185.78,173.26,185.56,173.59Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_408",
    "data-name": "Trazado 408",
    d: "M127.27,249.58s-21.79,23.85-21.79,51.9,17.79,63.23,16.12,83.33S104.43,431.7,99.82,445.1s-3.76,17.59-3.76,17.59H210.78l-2.31-76.8-.2-40.44.68-36.6-32.5-44v-9l-47.74-12.56Z",
    fill: "#2650ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_409",
    "data-name": "Trazado 409",
    d: "M209.52,404s39.71,42.09,40.54,42.76,31.36,0,31.36,0l18.71,10.47s-1.11,3.57-7.35,1.79c0,0,1.5,2-.95,3.75H281.14l-9.53-.11H240.19L210.34,442Z",
    fill: "#c4947f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1585",
    "data-name": "Grupo 1585",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_410",
    "data-name": "Trazado 410",
    d: "M115.65,281.88c-.24,14.05,3.76,28.29,12.11,39.6s21.12,19.47,35,21.35c4.68.63,9.47.58,14,1.85,4.07,1.14,7.78,3.3,11.78,4.66A31.671,31.671,0,0,0,203,350.76c1.89-.25,4-.9,4.72-2.67,1-2.63-1.9-5-4.38-6.34-30.42-16.5-62.22-36.4-87.64-59.87"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_411",
    "data-name": "Trazado 411",
    d: "M164.18,326.54s72.47,32,82.61,32,67-51.64,67-51.64l-13.53-16.28-54.82,32.12-62.77-34.4Z",
    fill: "#c4947f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_412",
    "data-name": "Trazado 412",
    d: "M290.86,296.68l13.32-8.32s5.84-11.46,8.92-12.8,20.55-7.76,20.55-7.76l17.7-1.63s1.59,2.26-3.33,5.59c-3.66,2.48-10.77,3.8-10.77,3.8l-4.37,2s3.29,3.7,5.91,3.6c2.34-.09,10.53-4.88,13.1-3.86s-.77,7.71-.77,7.71h0c-1.76,3.62-9.29,15.46-11.61,18.18C337.93,305,327.23,305,327.23,305l-11.52,1.42-12.88,10Z",
    fill: "#c4947f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_413",
    "data-name": "Trazado 413",
    d: "M137.77,253.23s-11.18.89-18.36,12.45c-5.53,8.9-4,17.46-.33,28.9,1.61,5,5.56,10.39,9.81,14.49,9.79,9.46,30.84,22.52,30.84,22.52l32.76-37.15S156.4,258.28,137.77,253.23Z",
    fill: "#2650ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_414",
    "data-name": "Trazado 414",
    d: "M151.15,259l.2.15.59.48,2.24,1.88,8.47,7.17,30,25.59.17.15-.15.18-32,36.3c-.26.3-.52.6-.77.87l-.14.16-.19-.11c-6-3.63-11.81-7.35-17.24-11.16s-10.59-7.72-14.52-12.42a49.63,49.63,0,0,1-9.33-14.52A34.36,34.36,0,0,1,117,272.4a33.8,33.8,0,0,1,2-5.53,28.29,28.29,0,0,1,5.18-7.79,25.469,25.469,0,0,1,4.53-3.8l1.33-.78c.3-.17.46-.24.46-.24l-.43.29-1.3.81a27.119,27.119,0,0,0-4.44,3.86,28.381,28.381,0,0,0-5.06,7.77,32.72,32.72,0,0,0-1.9,5.49,34.78,34.78,0,0,0-.93,6.45,35.41,35.41,0,0,0,2.52,14.62,49.36,49.36,0,0,0,9.29,14.37c3.91,4.65,9.05,8.5,14.45,12.32s11.2,7.5,17.22,11.12l-.33.06.77-.88,32-36.25v.32l-29.87-25.73-8.38-7.27-2.2-1.94-.56-.5Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_415",
    "data-name": "Trazado 415",
    d: "M176.45,255.73a3.89,3.89,0,0,1-.06.79c-.07.52-.2,1.27-.42,2.23a30,30,0,0,1-3,7.72l-.11.2-.19-.14a87.331,87.331,0,0,0-16.66-8.43,170.763,170.763,0,0,0-20.23-6.41c-2.63-.7-4.78-1.17-6.26-1.51l-1.71-.42a2.4,2.4,0,0,1-.58-.18,2.46,2.46,0,0,1,.6.08l1.73.32c1.49.29,3.66.7,6.31,1.35a151.736,151.736,0,0,1,20.33,6.29,81.89,81.89,0,0,1,16.8,8.59l-.3.06a31.451,31.451,0,0,0,3.1-7.57c.25-.94.41-1.69.52-2.2a4.479,4.479,0,0,1,.13-.77Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_416",
    "data-name": "Trazado 416",
    d: "M196.82,155.58a12.94,12.94,0,0,0,4.62-13.52,14.77,14.77,0,0,0-10.36-10.14,16.331,16.331,0,0,0-3-.47,13.45,13.45,0,0,0-6.53-1.65c-.4-2.67-2.87-4.68-5.5-5.3a16.56,16.56,0,0,0-8,.56,13.59,13.59,0,0,0-21.85,1.63,11.14,11.14,0,0,0-16.25,7.36,11.06,11.06,0,0,0-7.83,4,10.83,10.83,0,0,0-1.7,2.92,10.43,10.43,0,0,0-1.85,4.18,12.52,12.52,0,0,0-5,23,11.45,11.45,0,0,0,3,18.09,14.68,14.68,0,0,0,1.48,11.42,7.06,7.06,0,0,0,3.78,3.3,2.84,2.84,0,0,0,.34.78c1.31,1.91,4.35,1,6.11-.53,4.3-3.64,6.49-9.2,7.57-14.73s1.21-11.19,2.24-16.72a.81.81,0,0,1,.07-.39A15.45,15.45,0,0,1,141,163a39.5,39.5,0,0,0,5.1,3.05,16.58,16.58,0,0,0,19.17-4.43,24.29,24.29,0,0,0,15.65,5.17c5.61-.16,11.12-1.38,15.31-5.11a7.65,7.65,0,0,0,2.33-3.57,2.38,2.38,0,0,0-1.74-2.53Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_417",
    "data-name": "Trazado 417",
    d: "M127.05,194.72c-.28-.14-11.31-3.94-11.49,7.5s11.34,9.26,11.37,8.93S127.05,194.72,127.05,194.72Z",
    fill: "#c4947f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_418",
    "data-name": "Trazado 418",
    d: "M123.5,206.76a3.473,3.473,0,0,1-.54.29,2,2,0,0,1-1.49,0c-1.2-.46-2.19-2.39-2.21-4.45a6.52,6.52,0,0,1,.6-2.85,2.27,2.27,0,0,1,1.52-1.5,1,1,0,0,1,1.17.56c.15.32.07.55.13.57s.25-.19.16-.66a1.29,1.29,0,0,0-.43-.73,1.56,1.56,0,0,0-1.1-.3,2.78,2.78,0,0,0-2.11,1.74,6.8,6.8,0,0,0-.74,3.17c0,2.31,1.18,4.49,2.83,5a2.13,2.13,0,0,0,1.83-.28C123.48,207,123.54,206.78,123.5,206.76Z",
    fill: "#77544d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_419",
    "data-name": "Trazado 419",
    d: "M200.81,140.2a.639.639,0,0,0,.1.26,5.228,5.228,0,0,1,.21.82,8.74,8.74,0,0,1-2.35,7.71,9,9,0,0,1-6.06,2.64l.21-.18a19.68,19.68,0,0,1-4.58,10,15.31,15.31,0,0,1-5,3.87,12.68,12.68,0,0,1-6.56,1.07,22.3,22.3,0,0,1-6.37-1.5,17.08,17.08,0,0,1-5.33-3.1h.35a20.74,20.74,0,0,1-9.5,5.47,16.26,16.26,0,0,1-8.61-.59,16.91,16.91,0,0,1-5-2.71,13.408,13.408,0,0,1-1.14-1,2.259,2.259,0,0,1-.36-.38s.54.47,1.6,1.24a17.51,17.51,0,0,0,5,2.55,16.11,16.11,0,0,0,8.42.47,20.43,20.43,0,0,0,9.24-5.41l.17-.16.17.15a16.84,16.84,0,0,0,5.17,3,21.89,21.89,0,0,0,6.23,1.46,12.07,12.07,0,0,0,6.3-1,14.59,14.59,0,0,0,4.81-3.73,19.27,19.27,0,0,0,4.54-9.74v-.18h.18a8.69,8.69,0,0,0,5.82-2.45,8.4,8.4,0,0,0,2.35-4.29,9,9,0,0,0,.12-3.17C200.9,140.58,200.78,140.2,200.81,140.2Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_420",
    "data-name": "Trazado 420",
    d: "M120.13,144.48a25.428,25.428,0,0,0-1,3.93,16.37,16.37,0,0,0,1.9,10.16l.1.17-.15.12a10.53,10.53,0,0,0-3,4.67,10.08,10.08,0,0,0,0,6.08,10.57,10.57,0,0,0,4.91,6l.21.11-.1.22a13.1,13.1,0,0,0-1.29,7.14,14.25,14.25,0,0,0,1.69,5.54,16.14,16.14,0,0,0,3.27,4,1.341,1.341,0,0,1-.3-.2,9.048,9.048,0,0,1-.81-.65,12.85,12.85,0,0,1-2.43-3,14.19,14.19,0,0,1-1.84-5.64,13.48,13.48,0,0,1,1.26-7.41l.11.33a11,11,0,0,1-5.18-6.32,10.58,10.58,0,0,1,.06-6.4,10.9,10.9,0,0,1,3.18-4.86v.29a16.29,16.29,0,0,1-1.78-10.43,14.42,14.42,0,0,1,.8-2.92,6.529,6.529,0,0,1,.32-.73C120.08,144.55,120.12,144.47,120.13,144.48Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_421",
    "data-name": "Trazado 421",
    d: "M120.85,210.76a8.74,8.74,0,0,0-.22,2.06,3,3,0,0,0,.83,1.93,2.53,2.53,0,0,0,2.35.66,2.11,2.11,0,0,0,1.42-1.89,4,4,0,0,0-.4-2.12c-.56-1.15-1.06-1.81-1-1.86a5.38,5.38,0,0,1,1.31,1.7,4.19,4.19,0,0,1,.55,2.33,3,3,0,0,1-.47,1.39,2.32,2.32,0,0,1-1.29.95,2.93,2.93,0,0,1-2.83-.83,3.26,3.26,0,0,1-.86-2.24A3.1,3.1,0,0,1,120.85,210.76Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_422",
    "data-name": "Trazado 422",
    d: "M185.91,288.79a4.387,4.387,0,0,1-.34.39l-1,1.05L180.73,294c-3.21,3.23-7.59,7.74-12.26,12.87s-8.75,9.93-11.66,13.43l-3.44,4.15-1,1.12a2,2,0,0,1-.35.37,3.782,3.782,0,0,1,.27-.43l.87-1.18c.76-1,1.89-2.48,3.31-4.27,2.84-3.56,6.88-8.39,11.56-13.54s9.11-9.62,12.39-12.78c1.64-1.58,3-2.84,3.93-3.7l1.1-1a1.791,1.791,0,0,1,.46-.25Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_423",
    "data-name": "Trazado 423",
    d: "M358.52,277.86l9.13-9,10.86-1.9,38.28,14.93s6,10.56,1.36,18.32-9,7.48-9,7.48l-8.14-5.16L372,305.76s-12.22-8.42-12.49-10.05-.27-11.4-.27-11.4l-1.15-1.62A3.74,3.74,0,0,1,358.52,277.86Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_424",
    "data-name": "Trazado 424",
    d: "M359.87,292.63a112.181,112.181,0,0,0,18.34,8.76,10.62,10.62,0,0,0,4.41.93,5.07,5.07,0,0,0,3.78-2.05,4.17,4.17,0,0,0,.38-4.21,7.68,7.68,0,0,0-3.28-2.83l-11.61-6.6",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_425",
    "data-name": "Trazado 425",
    d: "M359.81,292.74A114.351,114.351,0,0,0,370,298.13a57.592,57.592,0,0,0,10.32,4.09c2.54.6,5.53-.1,6.62-2.73s-.7-4.77-2.93-6.09c-4-2.35-8.06-4.59-12.09-6.88a.121.121,0,1,0-.12.21L383,293.1c1.75,1,3.84,2.11,4,4.37a4.52,4.52,0,0,1-4.07,4.68c-2.14.3-4.29-.69-6.24-1.45s-4-1.61-5.94-2.5a114.318,114.318,0,0,1-10.86-5.68c-.14-.08-.26.14-.12.22Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_426",
    "data-name": "Trazado 426",
    d: "M359.63,296c5,5.57,11.83,10.71,17.58,16.56a8.32,8.32,0,0,0,1.39-9.81",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_427",
    "data-name": "Trazado 427",
    d: "M359.54,296.07c5.42,6,11.93,10.82,17.58,16.56a.15.15,0,0,0,.18,0,8.5,8.5,0,0,0,1.41-10c-.08-.14-.29,0-.21.13a8.3,8.3,0,0,1,.15,7.53,5.16,5.16,0,0,1-1.16,1.74c-.35.26-.31.19-.68-.11a8.541,8.541,0,0,1-.74-.74c-1.12-1.09-2.27-2.16-3.43-3.22-4.37-4-8.95-7.73-12.93-12.11-.1-.12-.28.06-.17.18Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_428",
    "data-name": "Trazado 428",
    d: "M377.37,274.39c-6.7-3.9-17.38-5.48-29.22-7.46l-11.58,21.14s20.89,3.16,29.77,7c12.7,5.51,19.56,22.12,19.56,22.12l16.76-20.76S398.35,284.45,377.37,274.39Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_429",
    "data-name": "Trazado 429",
    d: "M375.7,280.06,373.59,284c1.35.89,2.74,1.86,2.21,3.58-.63,2.05-2.74,2.68-5.23,2l-.9,1.67-.77-.24.91-1.68a5.71,5.71,0,0,1-3-2.44l.84-.73a5.07,5.07,0,0,0,2.69,2.25l2.08-3.87c-1.29-.88-2.56-1.85-2-3.58.61-2,2.67-2.67,5.07-2.05l.91-1.67.76.24-.91,1.68a6,6,0,0,1,2.65,1.83l-.77.78a5.11,5.11,0,0,0-2.43-1.71Zm-2.63,4.87-2,3.68c1.75.45,3.13,0,3.53-1.25C374.93,286.33,374.09,285.62,373.07,284.93Zm-.13-1.4,2-3.71c-1.69-.38-3,.1-3.4,1.34C371.22,282.16,372,282.85,372.94,283.53Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_430",
    "data-name": "Trazado 430",
    d: "M376.54,275.94l.52.23,1.51.73c.66.32,1.48.73,2.4,1.26s2,1.11,3.19,1.87a61.212,61.212,0,0,1,8.09,5.94,43.891,43.891,0,0,1,8.63,9.91l.07.12-.09.11-14,17.68-.25.32-.17-.38a49.069,49.069,0,0,0-6-10.06,35.15,35.15,0,0,0-9.15-8.38,31.619,31.619,0,0,0-7.74-3.25c-2.66-.81-5.31-1.52-7.91-2.18-5.21-1.31-10.25-2.46-15-3.47l-.33-.07.17-.28c3.6-6.22,6.89-11.89,9.78-16.87l.07-.12h.13a168.319,168.319,0,0,1,19.42,4,33.193,33.193,0,0,1,5.05,1.94,14,14,0,0,1,1.66.91,2.427,2.427,0,0,1-.44-.2c-.28-.14-.7-.37-1.27-.61a36.235,36.235,0,0,0-5.07-1.83,173.422,173.422,0,0,0-19.42-3.84l.21-.1-9.71,16.92-.16-.36c4.78,1,9.82,2.14,15,3.45,2.61.66,5.27,1.36,7.94,2.18a31.49,31.49,0,0,1,7.86,3.3,35.22,35.22,0,0,1,9.28,8.51,48.5,48.5,0,0,1,6.08,10.18l-.42-.06,14.07-17.63v.23a44.191,44.191,0,0,0-8.48-9.86,63.08,63.08,0,0,0-8-6c-1.15-.77-2.22-1.37-3.14-1.91s-1.72-1-2.38-1.31l-1.48-.78A2.514,2.514,0,0,1,376.54,275.94Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_431",
    "data-name": "Trazado 431",
    d: "M386.32,272.41c-.22.17-22.25,7.09-22.25,7.09l-7.26,3.09s3.09,4.91,7.9,3.91,6.17-2,6.17-2l7.72.36s3.23,13.64,27.56,7.1",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_432",
    "data-name": "Trazado 432",
    d: "M406.16,292a2.629,2.629,0,0,1-.58.18l-1.7.43a42.121,42.121,0,0,1-6.43,1.15,31,31,0,0,1-4.6.13h-1.28l-1.31-.2-1.35-.2-1.37-.37a18.193,18.193,0,0,1-2.76-1,16.43,16.43,0,0,1-2.62-1.69,11.2,11.2,0,0,1-3.8-5.4l.23.19-7.72-.35.16-.05a15.549,15.549,0,0,1-3.83,1.46,23.911,23.911,0,0,1-3,.66,6.38,6.38,0,0,1-3.07-.38,9.88,9.88,0,0,1-4.52-3.72l-.16-.25.28-.12L364,279.4h0l16.14-5,4.55-1.39,1.21-.37a2.1,2.1,0,0,1,.42-.11,1.723,1.723,0,0,1-.4.18l-1.18.43-4.52,1.52-16.08,5.19h0l-7.26,3.1.12-.36a9.46,9.46,0,0,0,4.27,3.51,6.15,6.15,0,0,0,2.83.35,25.259,25.259,0,0,0,2.95-.65,15.54,15.54,0,0,0,3.66-1.38l.09-.05h.07l7.72.37h.18v.19a10.53,10.53,0,0,0,1.45,2.88,12.589,12.589,0,0,0,2.17,2.26A15,15,0,0,0,385,291.6a17,17,0,0,0,2.69,1l1.31.4,1.32.21,1.29.21,1.26.06a33.818,33.818,0,0,0,4.55-.07,50.176,50.176,0,0,0,6.43-1l1.71-.36A4.159,4.159,0,0,1,406.16,292Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_433",
    "data-name": "Trazado 433",
    d: "M354.69,272.55c0,.87-1,1.58-2.14,1.58s-2.15-.71-2.15-1.58,1-1.59,2.15-1.59S354.69,271.67,354.69,272.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_434",
    "data-name": "Trazado 434",
    d: "M385.79,308.07c0,1.14.68,2.07,1.52,2.07s1.53-.93,1.53-2.07-.69-2.06-1.53-2.06S385.79,306.94,385.79,308.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_435",
    "data-name": "Trazado 435",
    d: "M649.85,407.38l-3.3.85-134.93,3.79-4.41,50.56,145.39.22,2.75-3.57Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_436",
    "data-name": "Trazado 436",
    d: "M550.78,215.8l16.67-7.64,7.82-9.91,51.45-6.86,7.21,9.37,40.15,26.15S661.69,371,660,383.69s-10.15,23.69-10.15,23.69-87.34,23.27-118.13,11.43c0,0-20.89-13-18.78-34.19s13.4-79.69,13.4-79.69Z",
    fill: "#2650ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_437",
    "data-name": "Trazado 437",
    d: "M414.39,277.9l70.74,19.71s-.42-7.81,6.24-9.31c0,0,41.58-58.88,46.15-63.87s13.26-8.63,13.26-8.63l-29.84,118s-25.9,13.76-36.47,11.68-38-11.64-54.23-22.87L405.3,307.08Z",
    fill: "#2650ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_438",
    "data-name": "Trazado 438",
    d: "M495.18,323.63a4.378,4.378,0,0,1-.26-1.09c-.16-.81-.36-1.8-.59-3a75.156,75.156,0,0,0-2.6-9.6,54.253,54.253,0,0,0-2.1-5.05,40,40,0,0,0-2.17-3.9c-1.36-2.15-2.4-3.34-2.33-3.41a4.679,4.679,0,0,1,.78.8,11.466,11.466,0,0,1,.84,1,15.12,15.12,0,0,1,1,1.4,33.992,33.992,0,0,1,2.29,3.89,46.094,46.094,0,0,1,2.16,5.09,58.784,58.784,0,0,1,2.47,9.71c.21,1.26.36,2.29.43,3a4.529,4.529,0,0,1,.08,1.16Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_439",
    "data-name": "Trazado 439",
    d: "M671.55,225.67S641,222.55,629.2,249s-12.67,100.64-12.67,100.64c-1.4-2.75-26.55,18.05-31.51,22.92l-51.4,14.23,9,33s63.23-6.47,79.77-14.69c18.74-9.3,32.23-12.18,37.62-22.46s18.66-72.1,20.12-92.11S687.11,230.72,671.55,225.67Z",
    fill: "#2650ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_440",
    "data-name": "Trazado 440",
    d: "M593.44,214.14a1.853,1.853,0,0,1-.22.4c-.16.25-.39.63-.71,1.1-.63,1-1.58,2.3-2.8,4-2.4,3.32-6,7.78-9.6,13l-.25.36-.2-.39c-.33-.64-.67-1.32-1-2-3.15-6.16-6-11.76-8-15.82-1-2-1.77-3.61-2.37-4.82l-.62-1.33a2.179,2.179,0,0,1-.19-.47,2.8,2.8,0,0,1,.28.43c.16.29.43.76.71,1.28l2.52,4.74c2.11,4,5,9.59,8.14,15.75l1,2h-.44c3.65-5.29,7.27-9.7,9.75-13l2.92-3.85A12.837,12.837,0,0,1,593.44,214.14Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_441",
    "data-name": "Trazado 441",
    d: "M631.76,202.7a3.59,3.59,0,0,1-.45.45l-1.35,1.2c-1.16,1.06-2.86,2.57-4.9,4.52a175.864,175.864,0,0,0-14.94,16.07c-2.33,2.86-4.48,5.68-6.37,8.3l-.25.35-.17-.39-6-13.54-1.7-3.92c-.18-.42-.32-.77-.43-1.05a1.591,1.591,0,0,1-.13-.37,1.461,1.461,0,0,1,.2.34c.14.27.3.61.51,1,.45,1,1.06,2.26,1.82,3.86L603.78,233l-.43-.05c1.88-2.64,4-5.47,6.37-8.34a156.313,156.313,0,0,1,15.09-16c2.07-1.92,3.81-3.39,5-4.4l1.42-1.14a2.367,2.367,0,0,1,.53-.37Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_442",
    "data-name": "Trazado 442",
    d: "M661.22,379.75s-.08.2-.25.59l-.78,1.71a39,39,0,0,1-3.83,6.19,40.239,40.239,0,0,1-8.27,8.16,55.263,55.263,0,0,1-13.72,7.3,106.8,106.8,0,0,1-18.45,4.84c-3.39.65-6.94,1.17-10.55,1.95s-7.35,1.61-11.23,2.27c-15.52,2.59-32.89,4.89-51.51,7.25h-.21l-.06-.21c-2.89-10.6-5.9-21.64-9-33l-.07-.27.27-.05c3.26-.62,6.74-1.37,10.23-2.2,7.27-1.72,14.35-3.72,21.32-5.62s13.92-3.44,20.08-6.53a40.719,40.719,0,0,0,8.36-5.7c2.53-2.19,4.87-4.53,7.23-6.77a65.855,65.855,0,0,1,7.34-6.22,26.73,26.73,0,0,1,8.34-4.08l-.17.19c3.88-27.4,7.12-50.33,9.4-66.44,1.16-8,2.06-14.36,2.69-18.7.31-2.14.55-3.8.72-4.93.09-.55.15-1,.2-1.26s.07-.43.07-.43a3.4,3.4,0,0,1,0,.43c0,.3-.09.72-.16,1.27-.15,1.14-.37,2.79-.65,4.94-.6,4.34-1.46,10.68-2.56,18.72-2.23,16.11-5.41,39.06-9.21,66.46v.15h-.15a26.459,26.459,0,0,0-8.19,4,65.471,65.471,0,0,0-7.27,6.19c-2.36,2.24-4.7,4.59-7.25,6.79a41.13,41.13,0,0,1-8.45,5.78c-6.24,3.13-13.24,4.63-20.17,6.58s-14.06,3.91-21.34,5.63c-3.5.83-7,1.58-10.25,2.2l.2-.32c3.09,11.34,6.09,22.39,9,33l-.28-.18c18.61-2.34,36-4.62,51.5-7.18,15.31-3.41,29.36-4.72,40.19-8.93a55.07,55.07,0,0,0,13.68-7.2A40.41,40.41,0,0,0,660.11,382c.35-.74.63-1.3.81-1.69A3.931,3.931,0,0,1,661.22,379.75Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1586",
    "data-name": "Grupo 1586",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_443",
    "data-name": "Trazado 443",
    d: "M651.08,361.34a8,8,0,0,0-1.6-3.65c-3.72-5.23-10.08-8.1-16.44-8.95s-9.95-.35-16.29.69l-.4.29c10.72-.82,18.53,3.38,25.59,11.58a16,16,0,0,0,3.28,3.3,4.14,4.14,0,0,0,4.4.29,3.79,3.79,0,0,0,1.46-3.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_444",
    "data-name": "Trazado 444",
    d: "M646.55,357.19a33.164,33.164,0,0,0-3.38-3.43A23.27,23.27,0,0,0,632.73,349a35.639,35.639,0,0,0-11.58-.15c-1.48.19-2.67.38-3.5.51a6.19,6.19,0,0,1-1.3.14,6.122,6.122,0,0,1,1.26-.34c.82-.19,2-.43,3.49-.68a33.63,33.63,0,0,1,11.73,0,22.49,22.49,0,0,1,10.57,5,16.8,16.8,0,0,1,2.44,2.61,5.6,5.6,0,0,1,.71,1.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_445",
    "data-name": "Trazado 445",
    d: "M666.07,226.81a41.407,41.407,0,0,0-6.72-1,27,27,0,0,0-3.43.09c-.61.07-1.24.2-1.88.29a13.1,13.1,0,0,0-2,.45,25,25,0,0,0-8.12,3.76,32.59,32.59,0,0,0-6.54,6.17c-.45.52-.8,1.11-1.2,1.63a10.507,10.507,0,0,0-1.08,1.58c-.61,1.07-1.25,2-1.72,3s-.87,1.79-1.24,2.55-.59,1.45-.82,2-.38.91-.52,1.26-.2.43-.22.42a1.4,1.4,0,0,1,.12-.46c.12-.35.26-.78.43-1.29s.42-1.25.74-2l1.19-2.61c.45-1,1.07-1.94,1.67-3,.3-.55.71-1,1.08-1.61a12.391,12.391,0,0,1,1.2-1.67,31.46,31.46,0,0,1,6.62-6.29,25,25,0,0,1,8.29-3.81,13.484,13.484,0,0,1,2-.43c.66-.09,1.3-.21,1.92-.27a27.192,27.192,0,0,1,3.48,0l1.52.11c.47.07.91.15,1.33.23a12.2,12.2,0,0,1,2.11.47l1.31.4a2.322,2.322,0,0,1,.48.03Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_446",
    "data-name": "Trazado 446",
    d: "M531.43,256.57a1,1,0,0,1,0,.28v.82c0,.75-.13,1.8-.24,3.14-.21,2.72-.57,6.66-1,11.53-1,9.73-2.53,23.15-4.71,37.92s-4.56,28.07-6.45,37.66c-.94,4.8-1.73,8.68-2.32,11.35-.29,1.3-.51,2.33-.68,3.07-.07.33-.14.59-.19.8a.91.91,0,0,1-.08.27,1,1,0,0,1,0-.28,5.75,5.75,0,0,1,.14-.81c.14-.74.34-1.78.58-3.09.52-2.73,1.26-6.6,2.16-11.38,1.79-9.61,4.11-22.91,6.3-37.67s3.79-28.16,4.85-37.88c.51-4.83.93-8.76,1.22-11.51.15-1.33.26-2.38.34-3.13a5.09,5.09,0,0,1,.1-.82.839.839,0,0,1-.02-.27Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1587",
    "data-name": "Grupo 1587",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_447",
    "data-name": "Trazado 447",
    d: "M520.94,333.75c3.36-12.49,4.67-26.3,6.39-39.48-2.13,14.93-9.4,32.28-17.72,44.86C513.75,337.31,517.61,335.51,520.94,333.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1588",
    "data-name": "Grupo 1588",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_448",
    "data-name": "Trazado 448",
    d: "M595.5,215.36c1.75,7.52,3.33,15.26,6,22.53a4.63,4.63,0,0,0,1.3,2.18,3,3,0,0,0,2.79.29,6.8,6.8,0,0,0,2.36-1.66c3.64-3.62,5.61-8.52,7.9-13.11,3.85-7.73,12.42-19.62,14.22-21.43-10.74,9-18.68,19.27-26.46,29.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1589",
    "data-name": "Grupo 1589",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_449",
    "data-name": "Trazado 449",
    d: "M568.49,209.93a198.4,198.4,0,0,0,9.87,29.47c.19.45.47,1,.95,1a1.485,1.485,0,0,0,1.12-.74c4.81-6.49,9.72-16.89,12.18-24.33l-12.72,17.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_450",
    "data-name": "Trazado 450",
    d: "M601.15,320a2.12,2.12,0,0,1-.54.26l-1.59.66c-1.38.57-3.39,1.35-5.89,2.28-5,1.86-12,4.26-19.8,6.56s-15,4.06-20.19,5.2c-2.61.58-4.72,1-6.19,1.28l-1.69.3a3.337,3.337,0,0,1-.6.08,2.4,2.4,0,0,1,.58-.18l1.67-.4,6.14-1.44c5.19-1.23,12.33-3.05,20.14-5.34S588,324.59,593,322.82l6-2.12,1.62-.56A2.211,2.211,0,0,1,601.15,320Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_451",
    "data-name": "Trazado 451",
    d: "M587.64,257.53a1.41,1.41,0,0,1-.23.17l-.69.44c-.62.38-1.52,1-2.66,1.73-2.29,1.52-5.46,3.93-9.57,6.67a47.944,47.944,0,0,1-7.06,3.92,27.48,27.48,0,0,1-9,2.23,18.21,18.21,0,0,1-10-2,12.54,12.54,0,0,1-4.1-3.62,8.78,8.78,0,0,1-1.71-5.37,6,6,0,0,1,.84-2.77,5.77,5.77,0,0,1,2.08-2,7.78,7.78,0,0,1,5.41-.81,6.75,6.75,0,0,1,4.37,2.94,8.59,8.59,0,0,1,1.38,4.87,10.28,10.28,0,0,1-1.15,4.68,10.479,10.479,0,0,1-2.94,3.47,14.62,14.62,0,0,1-7.55,2.81,19.41,19.41,0,0,1-6.65-.59,31.109,31.109,0,0,1-4.75-1.64,30.244,30.244,0,0,1-2.87-1.37l-.72-.39q-.25-.13-.24-.15a.841.841,0,0,1,.26.1l.75.35c.66.3,1.62.75,2.9,1.27a33,33,0,0,0,4.74,1.55,19.73,19.73,0,0,0,6.54.51,14.38,14.38,0,0,0,7.33-2.79,10,10,0,0,0,2.79-3.34,9.9,9.9,0,0,0,1.08-4.47,8.11,8.11,0,0,0-1.31-4.6,6.28,6.28,0,0,0-4.07-2.71,7.22,7.22,0,0,0-5,.76,5.07,5.07,0,0,0-1.89,1.79,5.47,5.47,0,0,0-.77,2.53,8.22,8.22,0,0,0,1.62,5,12,12,0,0,0,3.93,3.48,17.72,17.72,0,0,0,9.72,2,27.111,27.111,0,0,0,8.87-2.15,47.163,47.163,0,0,0,7-3.83c4.12-2.68,7.33-5.06,9.66-6.53,1.16-.74,2.08-1.3,2.71-1.65l.73-.4a.918.918,0,0,1,.22-.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_452",
    "data-name": "Trazado 452",
    d: "M625.1,284.27a.4.4,0,0,1-.22-.12l-.61-.42a18.926,18.926,0,0,0-2.44-1.4,19.86,19.86,0,0,0-10-2A19.46,19.46,0,0,0,598.5,287a15.71,15.71,0,0,0-3.92,7.93,8.509,8.509,0,0,0,.56,4.59,6.48,6.48,0,0,0,3.17,3.43A6.07,6.07,0,0,0,603,303a7.66,7.66,0,0,0,3.67-2.77,5.92,5.92,0,0,0,1-2,7.211,7.211,0,0,0,.28-2.21,9.131,9.131,0,0,0-1.09-4.16,10.51,10.51,0,0,0-2.59-3.22,11.861,11.861,0,0,0-3.41-1.9,15.651,15.651,0,0,0-7-.73,26.85,26.85,0,0,0-9.7,3.42c-1.07.59-1.89,1.08-2.44,1.42l-.64.37-.22.12a1.073,1.073,0,0,1,.19-.16l.61-.42c.54-.36,1.34-.88,2.4-1.51a36.106,36.106,0,0,1,4-2,21.9,21.9,0,0,1,5.75-1.58,15.85,15.85,0,0,1,7.18.68,12.24,12.24,0,0,1,3.56,2,10.861,10.861,0,0,1,2.72,3.34,9.641,9.641,0,0,1,1.17,4.39,7.891,7.891,0,0,1-.29,2.35,6.581,6.581,0,0,1-1,2.19,8.17,8.17,0,0,1-3.91,3,6.65,6.65,0,0,1-5-.13,7,7,0,0,1-3.42-3.7,9.089,9.089,0,0,1-.6-4.87,16.241,16.241,0,0,1,4.07-8.18,19.55,19.55,0,0,1,23.78-4.51,14,14,0,0,1,3.03,2.04Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_453",
    "data-name": "Trazado 453",
    d: "M682.41,260.06l-.23.09-.69.21a21.93,21.93,0,0,1-2.69.58,26.12,26.12,0,0,1-10.1-.48,25.529,25.529,0,0,1-6.52-2.61,15.8,15.8,0,0,1-3.18-2.33,9.48,9.48,0,0,1-2.35-3.48,6.671,6.671,0,0,1,0-4.41,5,5,0,0,1,3.18-3.3,5.12,5.12,0,0,1,4.62,1.06,6.61,6.61,0,0,1,2.44,4.25,9.64,9.64,0,0,1-.68,4.86,17,17,0,0,1-2.36,4.11,23.89,23.89,0,0,1-14.12,8.92,22.84,22.84,0,0,1-7,.35,23.83,23.83,0,0,1-9.61-3.14,17.47,17.47,0,0,1-3-2.18l.21.13.58.41a25.107,25.107,0,0,0,2.32,1.47,24.229,24.229,0,0,0,9.54,2.94,22.721,22.721,0,0,0,6.88-.4,23.58,23.58,0,0,0,13.8-8.81,16.243,16.243,0,0,0,2.29-4,9.25,9.25,0,0,0,.65-4.6,6.09,6.09,0,0,0-2.26-3.91,4.56,4.56,0,0,0-4.14-1,4.49,4.49,0,0,0-2.86,3,6.17,6.17,0,0,0,0,4.09,11.549,11.549,0,0,0,5.29,5.6,25.45,25.45,0,0,0,6.4,2.62,26.52,26.52,0,0,0,10,.64c1.18-.16,2.09-.34,2.7-.48l.69-.16A1.072,1.072,0,0,1,682.41,260.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_454",
    "data-name": "Trazado 454",
    d: "M526.51,285.6a20.242,20.242,0,0,0-1.41-1.91,11.6,11.6,0,0,0-5.31-3.48,11.26,11.26,0,0,0-9.13,1.18,7.4,7.4,0,0,0-3.5,4.09,3,3,0,0,0,.52,2.63,4,4,0,0,0,2.53,1.31,4.41,4.41,0,0,0,2.84-.5,5.64,5.64,0,0,0,2-2,10.611,10.611,0,0,0,1.29-5.36,17.65,17.65,0,0,0-2.55-9.08,18.59,18.59,0,0,0-4.22-4.85c-1.21-.94-2-1.34-1.94-1.39a2.639,2.639,0,0,1,.56.27,17.308,17.308,0,0,1,1.5,1,17.94,17.94,0,0,1,7.13,14.09,11,11,0,0,1-1.33,5.62,6.18,6.18,0,0,1-2.17,2.23,4.93,4.93,0,0,1-3.17.57,4.48,4.48,0,0,1-2.86-1.51,3.45,3.45,0,0,1-.61-3.07,7.84,7.84,0,0,1,3.74-4.38,11.6,11.6,0,0,1,9.49-1.12,11.48,11.48,0,0,1,5.36,3.7,11.342,11.342,0,0,1,1,1.47A2.541,2.541,0,0,1,526.51,285.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_455",
    "data-name": "Trazado 455",
    d: "M582.46,210.11a25.29,25.29,0,0,0-5.63,1.87,24.592,24.592,0,0,0-4.73,3.59,10.52,10.52,0,0,1,4.48-4,10.64,10.64,0,0,1,5.88-1.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_456",
    "data-name": "Trazado 456",
    d: "M615.08,218a5.62,5.62,0,0,1-2.15-.71,11.9,11.9,0,0,1-6.3-8.61,5.639,5.639,0,0,1,0-2.27c.1,0,.1.86.39,2.2A13,13,0,0,0,613.1,217,19.322,19.322,0,0,0,615.08,218Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_457",
    "data-name": "Trazado 457",
    d: "M551,359a8,8,0,0,1-1.34.47,14.556,14.556,0,0,1-1.6.44c-.64.14-1.35.33-2.16.44a36.787,36.787,0,0,1-5.72.51,37.71,37.71,0,0,1-13.78-2.51,36.381,36.381,0,0,1-5.17-2.49c-.72-.39-1.32-.82-1.86-1.17a15.285,15.285,0,0,1-1.35-1,8.1,8.1,0,0,1-1.09-.92c.07-.08,1.65,1.18,4.48,2.74a39.828,39.828,0,0,0,5.16,2.36,42.237,42.237,0,0,0,6.7,1.84,43.22,43.22,0,0,0,6.91.64,40.113,40.113,0,0,0,5.66-.39C549,359.55,551,358.93,551,359Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_458",
    "data-name": "Trazado 458",
    d: "M614.81,337.32a.862.862,0,0,1-.25-.08l-.7-.28-1.12-.46c-.45-.17-1-.33-1.58-.53a32.62,32.62,0,0,0-10.41-1.53,33.35,33.35,0,0,0-15,3.86,29.791,29.791,0,0,0-7.34,5.51,12,12,0,0,0-2.6,4,6.6,6.6,0,0,0,0,4.77,4.53,4.53,0,0,0,3.47,3,4.92,4.92,0,0,0,4.17-1.68,5.77,5.77,0,0,0,1.64-4.13,8.081,8.081,0,0,0-1.34-4.15,13.22,13.22,0,0,0-6.38-5.06,17.109,17.109,0,0,0-7.1-1.1,17.45,17.45,0,0,0-9.73,3.6,24.114,24.114,0,0,0-2.77,2.7.82.82,0,0,1,.14-.21l.46-.6a6.724,6.724,0,0,1,.81-.92,11.769,11.769,0,0,1,1.23-1.13,17.65,17.65,0,0,1,17.12-2.74,13.62,13.62,0,0,1,6.63,5.2,8.68,8.68,0,0,1,1.43,4.4,6.28,6.28,0,0,1-1.77,4.49,5.43,5.43,0,0,1-4.61,1.85,5,5,0,0,1-3.88-3.3,7,7,0,0,1,0-5.13,12.331,12.331,0,0,1,2.7-4.19,30,30,0,0,1,7.49-5.59,33.22,33.22,0,0,1,15.24-3.8,31.68,31.68,0,0,1,10.49,1.69c.59.22,1.12.4,1.56.58l1.12.52.67.32A1,1,0,0,1,614.81,337.32Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_459",
    "data-name": "Trazado 459",
    d: "M665.1,325.68a3.219,3.219,0,0,1-.4.27l-1.2.69c-.52.29-1.17.64-1.94,1s-1.63.8-2.63,1.19-2.08.86-3.28,1.26-2.48.8-3.84,1.21a64.341,64.341,0,0,1-9,1.74,63.632,63.632,0,0,1-9.22.3c-1.42-.09-2.76-.15-4-.32s-2.42-.32-3.48-.51-2-.4-2.83-.58-1.54-.37-2.11-.55l-1.32-.4a1.479,1.479,0,0,1-.45-.17,1.7,1.7,0,0,1,.48.07l1.34.31c.58.14,1.29.31,2.12.46s1.78.37,2.84.5,2.2.33,3.45.44,2.58.2,4,.27a67.323,67.323,0,0,0,9.14-.34,68.546,68.546,0,0,0,9-1.69c1.35-.38,2.65-.72,3.82-1.15s2.29-.8,3.28-1.19,1.87-.78,2.65-1.12,1.43-.65,2-.92l1.24-.59A2.071,2.071,0,0,1,665.1,325.68Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_460",
    "data-name": "Trazado 460",
    d: "M460,336.59a1.32,1.32,0,0,1,.14-.45l.51-1.24q.35-.79.78-1.95c.3-.77.64-1.64,1-2.62.71-1.94,1.41-4.31,2.12-6.94a86.248,86.248,0,0,0,1.73-8.72,70.745,70.745,0,0,0,.64-8.85,49.664,49.664,0,0,0-.53-7.22c-.08-.51-.13-1-.22-1.46s-.19-.88-.28-1.28a18.2,18.2,0,0,0-.5-2.05l-.36-1.28a1.33,1.33,0,0,1-.09-.46,3.365,3.365,0,0,1,.19.43l.45,1.26a15.633,15.633,0,0,1,.59,2c.1.41.21.83.32,1.29s.17.94.27,1.46a45.385,45.385,0,0,1,.64,7.28,66.124,66.124,0,0,1-.6,8.92,80.2,80.2,0,0,1-1.78,8.77c-.74,2.64-1.48,5-2.24,6.95-.36,1-.72,1.84-1.05,2.6s-.61,1.41-.87,1.93l-.59,1.19a2,2,0,0,1-.27.44Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_461",
    "data-name": "Trazado 461",
    d: "M595,214.32a1.7,1.7,0,0,1,0,.3c0,.23-.06.52-.1.89l-.42,3.4c-.36,3-1,7.23-1.74,12.5-1.56,10.54-4,25.06-7.26,41s-6.58,30.28-9.06,40.64c-1.25,5.14-2.27,9.32-3,12.25-.36,1.42-.64,2.53-.85,3.33-.09.35-.17.64-.23.86a1,1,0,0,1-.1.29,2.787,2.787,0,0,1,.05-.31q.07-.33.18-.87l.75-3.35c.68-2.93,1.65-7.12,2.84-12.29,2.38-10.38,5.65-24.73,8.9-40.65s5.75-30.43,7.41-41c.83-5.26,1.47-9.52,1.9-12.46.22-1.45.39-2.58.52-3.4.06-.36.11-.65.14-.88a1.479,1.479,0,0,1,.07-.25Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_462",
    "data-name": "Trazado 462",
    d: "M569.94,330.44a4.357,4.357,0,0,1-.4.41l-1.2,1.11a23.993,23.993,0,0,0-1.87,1.78l-1.11,1.17a16.174,16.174,0,0,0-1.2,1.35,40.191,40.191,0,0,0-2.51,3.29c-.42.62-.86,1.24-1.29,1.91l-1.22,2.12A49.291,49.291,0,0,0,555,353.63a65.114,65.114,0,0,0-2,10.69c-.11,1.67-.28,3.26-.29,4.75,0,.75,0,1.47-.05,2.16s0,1.36,0,2c0,1.27.08,2.42.14,3.42s.11,1.88.19,2.58l.13,1.64a2.466,2.466,0,0,1,0,.57,2,2,0,0,1-.11-.56c-.07-.43-.14-1-.24-1.62s-.2-1.58-.27-2.59-.2-2.15-.22-3.43c0-.64-.05-1.3-.07-2s0-1.42,0-2.17c0-1.5.14-3.1.24-4.78a63.3,63.3,0,0,1,2-10.8,48.218,48.218,0,0,1,4.2-10.13l1.25-2.14c.44-.66.9-1.29,1.33-1.91a38.362,38.362,0,0,1,2.58-3.28,16.238,16.238,0,0,1,1.24-1.34l1.15-1.14a19.582,19.582,0,0,1,1.94-1.74l1.27-1a2,2,0,0,1,.53-.37Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_463",
    "data-name": "Trazado 463",
    d: "M625.16,129.81c.62-20.9-13.83-38.46-34.75-38.5l-1.93.11a37.4,37.4,0,0,0-35.29,36.43c-.43,18.13-.68,38.15,0,47.83,1.38,20,21.6,22,21.6,22l.12,3.07,19.58,12.67,32.13-21.78Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_1",
    "data-name": "Sustracci\\xF3n 1",
    d: "M-10662.469-7135.539h-66.266a37.464,37.464,0,0,1,12.722-15.65,37.315,37.315,0,0,1,19.5-6.8l1.929-.11a34.823,34.823,0,0,1,10.75,1.685,32.886,32.886,0,0,1,9.146,4.666,35.587,35.587,0,0,1,12.223,16.209Z",
    transform: "translate(11284.977 7249.41)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_464",
    "data-name": "Trazado 464",
    d: "M558.14,141.48a2.86,2.86,0,0,0,2.92,2.73,2.73,2.73,0,0,0,2.8-2.74,2.87,2.87,0,0,0-2.92-2.74,2.74,2.74,0,0,0-2.8,2.75Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_465",
    "data-name": "Trazado 465",
    d: "M557.7,136.38c.37.36,2.45-1.37,5.53-1.54s5.42,1.25,5.74.85c.15-.17-.25-.83-1.27-1.49a7.83,7.83,0,0,0-4.62-1.14,7.6,7.6,0,0,0-4.38,1.69C557.79,135.53,557.51,136.22,557.7,136.38Z",
    fill: "#2d2d2d",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_466",
    "data-name": "Trazado 466",
    d: "M588.15,140.41a2.87,2.87,0,0,0,2.92,2.73,2.73,2.73,0,0,0,2.8-2.75,2.87,2.87,0,0,0-2.92-2.73,2.73,2.73,0,0,0-2.8,2.75Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_467",
    "data-name": "Trazado 467",
    d: "M588.33,133.78c.34.4,2.59-1.1,5.67-.93s5.26,1.83,5.61,1.47c.17-.16-.15-.85-1.1-1.62a7.88,7.88,0,0,0-4.47-1.63,7.55,7.55,0,0,0-4.53,1.2C588.53,133,588.17,133.61,588.33,133.78Z",
    fill: "#2d2d2d",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_468",
    "data-name": "Trazado 468",
    d: "M578.47,159.75c0-.17-1.93-.4-5.05-.62-.79,0-1.55-.15-1.71-.68a4,4,0,0,1,.39-2.36q1-2.91,2-6.12c2.75-8.71,4.69-15.85,4.34-15.95s-2.87,6.86-5.61,15.57l-1.89,6.14a4.54,4.54,0,0,0-.23,3.11,2,2,0,0,0,1.35,1.08,5.13,5.13,0,0,0,1.35.11C576.53,160,578.47,159.93,578.47,159.75Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_469",
    "data-name": "Trazado 469",
    d: "M587.65,161.37c-.5,0-.32,3.34-3,5.88s-6.3,2.36-6.3,2.83c0,.21.83.61,2.34.56a8.33,8.33,0,0,0,5.27-2.18,7.27,7.27,0,0,0,2.34-4.91C588.3,162.14,587.88,161.34,587.65,161.37Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_470",
    "data-name": "Trazado 470",
    d: "M588.14,123.62c.28.85,3.37.54,7,1.07s6.5,1.61,7,.87c.22-.36-.27-1.16-1.42-2a12.27,12.27,0,0,0-10.65-1.48C588.7,122.58,588,123.22,588.14,123.62Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_471",
    "data-name": "Trazado 471",
    d: "M558.68,128.44c.59.67,2.67-.18,5.21-.35s4.74.2,5.2-.56c.2-.37-.18-1-1.16-1.66a7.25,7.25,0,0,0-4.31-.9,7.17,7.17,0,0,0-4.08,1.64C558.68,127.38,558.43,128.11,558.68,128.44Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_472",
    "data-name": "Trazado 472",
    d: "M608.124,96.574c1-.55,9.105,5.524,10.236,7.246,4.211,1.738,6.82,12.29,7.44,18.7a69,69,0,0,1-.14,18.38c-.12.78-.57,4.1-.57,4.1-.85.76-1.72,7.91-2.86,8-1.61.13-3.16-10.8-3.47-11.63a48,48,0,0,0-1.34-7.37,67,67,0,0,1-2.3-11.86c-.28-5.57-2.39-13.83-2.68-19.4C612.39,101.68,607.214,97.094,608.124,96.574Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_535",
    "data-name": "Trazado 535",
    d: "M612.321,99.237c1.03-.519,5.386,3.632,6.231,4.32,4.964,4.028,7.024,11.594,7.663,17.64a59.671,59.671,0,0,1-.144,17.338c-.124.736-.587,3.868-.587,3.868-.875.717-18,20.683-19.177,20.768-1.658.123,4.2-14.127,6.4-19.88-.262-2.347.939-5.787.282-8.068-1.156-3.656-.255-6.555-.676-10.342-.288-5.254-.173-6.727-.472-11.982C611.793,111.9,611.384,99.728,612.321,99.237Z",
    transform: "translate(478.352 729.938) rotate(-92)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_473",
    "data-name": "Trazado 473",
    d: "M612.84,106.62,624.47,115a46.2,46.2,0,0,1,1.23,6.51l-11.56-7Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_474",
    "data-name": "Trazado 474",
    d: "M622.1,144.72c.33-.16,13.54-4.85,13.87,8.88s-13.51,11.23-13.54,10.83S622.1,144.72,622.1,144.72Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_475",
    "data-name": "Trazado 475",
    d: "M626.49,159.13c.06,0,.25.16.65.34a2.38,2.38,0,0,0,1.79,0c1.44-.57,2.6-2.9,2.61-5.37a8.1,8.1,0,0,0-.75-3.41,2.77,2.77,0,0,0-1.85-1.79,1.21,1.21,0,0,0-1.39.69c-.18.39-.08.66-.15.69s-.3-.23-.21-.8a1.56,1.56,0,0,1,.52-.87,1.78,1.78,0,0,1,1.31-.38,3.36,3.36,0,0,1,2.55,2.07,8.059,8.059,0,0,1,.93,3.8c0,2.77-1.38,5.39-3.35,6a2.51,2.51,0,0,1-2.19-.31C626.52,159.46,626.44,159.16,626.49,159.13Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_476",
    "data-name": "Trazado 476",
    d: "M574.52,197.67s13.15.32,26.56-9.21c0,0-5.59,14.66-22,15-.27,0-4.19-2.71-4.19-2.71Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_492",
    "data-name": "Trazado 492",
    d: "M485.76,387.82l-24.48-6.28a4.08,4.08,0,0,0-5,2.94l-6.94,27.07a4.07,4.07,0,0,0,2.93,5l51.6,13.23a4.08,4.08,0,0,0,5-2.94l6.94-27.06a4.08,4.08,0,0,0-2.94-5Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_493",
    "data-name": "Trazado 493",
    d: "M490,424.24c-.14,0,1.78-7.07,4.28-15.7s4.65-15.61,4.79-15.57-1.78,7.08-4.29,15.71S490.13,424.28,490,424.24Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_494",
    "data-name": "Trazado 494",
    d: "M534.52,391.24s-7.63.68-9.76.12-15.67-5.19-18.35-5.61a13.86,13.86,0,0,0-2-.17,13.41,13.41,0,0,0-6,1.3l-5.78,2.69,12.48,3.2s-.05,1.12-2.12,3.13-26.21,11.83-27.84,12.68-3.3,2-2.09,3.79,4.54,2.91,5.71,3a20.828,20.828,0,0,0,4.56-1s-7,3.79-7.13,5.21.81,3.88,2.19,3.68c1.16-.16,7.19-1.4,7.19-1.4s15.6-3.3,16.15-2.79-7.26,5.23-8.38,5.53-6,.22-7.14.77a2.53,2.53,0,0,0-.09,4.5,26.668,26.668,0,0,0,6.64,2.77,2.87,2.87,0,0,0-.68,3.29c1,1.78,1.61,1.78,3,2.19s4.86-.58,6.23-1.48,24.5-9.61,26-10.61,6.31-6.35,8.34-7.91a57.812,57.812,0,0,1,5.46-3.49Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_495",
    "data-name": "Trazado 495",
    d: "M478.59,417.21a6.379,6.379,0,0,1,1-.83,11.812,11.812,0,0,1,1.28-.85l.82-.5,1-.49a69.4,69.4,0,0,1,11-4.12,111.628,111.628,0,0,0,11.1-3.79l1-.42.85-.43c.53-.26,1-.49,1.35-.71a7.411,7.411,0,0,1,1.15-.62,7.431,7.431,0,0,1-1.06.77,13.625,13.625,0,0,1-1.32.78l-.85.46-1,.45a86.9,86.9,0,0,1-11.09,3.93,81.152,81.152,0,0,0-11,4l-1,.46-.83.46a14.173,14.173,0,0,0-1.31.78A7.391,7.391,0,0,1,478.59,417.21Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_496",
    "data-name": "Trazado 496",
    d: "M506.3,416.11a13,13,0,0,0,9.63-4.2,3.849,3.849,0,0,1-1,1.3,10.381,10.381,0,0,1-3.23,2.22,10.151,10.151,0,0,1-3.83.86,3.8,3.8,0,0,1-1.57-.18Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_497",
    "data-name": "Trazado 497",
    d: "M492.11,432.49a4.839,4.839,0,0,1,1-.32c.66-.17,1.61-.42,2.78-.75a80.408,80.408,0,0,0,17.47-7.25c1.06-.59,1.91-1.08,2.5-1.43a4.491,4.491,0,0,1,.94-.49,5.306,5.306,0,0,1-.85.64c-.56.39-1.39.92-2.43,1.55A66.74,66.74,0,0,1,496,431.72c-1.18.29-2.15.5-2.82.62a4.472,4.472,0,0,1-1.07.15Z",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_498",
    "data-name": "Trazado 498",
    d: "M465.37,376.58l-3.02,6.86,40.22,9.76Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_499",
    "data-name": "Trazado 499",
    d: "M500.26,393.2a1.781,1.781,0,0,1-.43,0,6.932,6.932,0,0,1-1.23-.09c-1.06-.1-2.6-.29-4.48-.61a133.1,133.1,0,0,1-14.51-3.45c-5.6-1.52-10.77-2.57-14.44-3.64-1.84-.51-3.31-1-4.32-1.35a9.27,9.27,0,0,1-1.54-.63,11.344,11.344,0,0,1,1.6.44c1,.29,2.51.72,4.35,1.19,3.68,1,8.86,2,14.49,3.49s10.7,2.86,14.44,3.59c1.86.36,3.38.61,4.44.77A11.834,11.834,0,0,1,500.26,393.2Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cash-register--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9047",
    "data-name": "Rect\\xE1ngulo 9047",
    width: 56.21,
    height: 26.3,
    transform: "translate(232.61 429.51)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_500",
    "data-name": "Trazado 500",
    d: "M268.87,462.59s9.53-26.73,12.54-34.9a4.14,4.14,0,0,1,3.9-2.71H436.59v37.61Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9048",
    "data-name": "Rect\\xE1ngulo 9048",
    width: 6.22,
    height: 34.25,
    transform: "translate(226.39 424.98)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_501",
    "data-name": "Trazado 501",
    d: "M285.84,425V406.92a3.9,3.9,0,0,1,3.29-3.85l109.19-17.18h26.05a4.92,4.92,0,0,1,4.92,4.92V425Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9049",
    "data-name": "Rect\\xE1ngulo 9049",
    width: 10.63,
    height: 24.38,
    transform: "translate(406.76 361.5)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9050",
    "data-name": "Rect\\xE1ngulo 9050",
    width: 44.85,
    height: 18.49,
    rx: 2.11,
    transform: "translate(389.65 343.01)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_502",
    "data-name": "Trazado 502",
    d: "M288.83,403.14a1.34,1.34,0,0,1,.34-.09l1-.18,3.95-.67,14.53-2.37,48-7.62,41.9-6.53h0l19.2.09,5.27.06h1.38a2.147,2.147,0,0,1,.47,0h-1.85l-5.27.05-19.2.09h0l-41.88,6.64-48,7.46-14.56,2.21-4,.57-1,.14Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_503",
    "data-name": "Trazado 503",
    d: "M424.92,361.5c0,.15-5.89.26-13.16.26s-13.16-.11-13.16-.26,5.89-.26,13.16-.26S424.92,361.36,424.92,361.5Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9051",
    "data-name": "Rect\\xE1ngulo 9051",
    width: 38.43,
    height: 13.03,
    transform: "translate(393.15 345.53)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_504",
    "data-name": "Trazado 504",
    d: "M426.29,349.33l-.51,2.54c.91.27,1.85.57,1.85,1.62,0,1.25-1.06,2-2.57,2l-.22,1.09h-.46l.21-1.1a3.36,3.36,0,0,1-2.1-.84l.34-.55a3,3,0,0,0,1.89.79l.49-2.51c-.86-.27-1.74-.59-1.74-1.65,0-1.21,1-1.94,2.48-2l.21-1.08h.47l-.22,1.09a3.51,3.51,0,0,1,1.79.56l-.29.57a3.06,3.06,0,0,0-1.62-.53Zm-.94,2.41.47-2.41c-1,.08-1.66.57-1.66,1.33C424.16,351.27,424.69,351.53,425.35,351.74Zm.31.76-.48,2.39c1.05-.05,1.76-.51,1.76-1.3C426.94,353,426.35,352.71,425.66,352.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_505",
    "data-name": "Trazado 505",
    d: "M419.83,349.33l-.5,2.54c.9.27,1.84.57,1.84,1.62,0,1.25-1.06,2-2.57,2l-.22,1.09h-.46l.22-1.1a3.36,3.36,0,0,1-2.11-.84l.35-.55a3,3,0,0,0,1.88.79l.5-2.51c-.87-.27-1.75-.59-1.75-1.65,0-1.21,1-1.94,2.48-2l.22-1.08h.46l-.21,1.09a3.58,3.58,0,0,1,1.79.56l-.3.57A3.06,3.06,0,0,0,419.83,349.33Zm-.94,2.41.48-2.41c-1,.08-1.67.57-1.67,1.33,0,.61.53.87,1.19,1.08Zm.31.76-.47,2.39c1-.05,1.75-.51,1.75-1.3,0-.59-.59-.88-1.28-1.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_506",
    "data-name": "Trazado 506",
    d: "M413.38,349.33l-.51,2.54c.91.27,1.85.57,1.85,1.62,0,1.25-1.07,2-2.57,2l-.22,1.09h-.47l.22-1.1a3.36,3.36,0,0,1-2.1-.84l.34-.55a3,3,0,0,0,1.89.79l.49-2.51c-.87-.27-1.74-.59-1.74-1.65,0-1.21,1-1.94,2.47-2l.22-1.08h.47l-.22,1.09a3.54,3.54,0,0,1,1.79.56l-.3.57A3,3,0,0,0,413.38,349.33Zm-.95,2.41.48-2.41c-1,.08-1.67.57-1.67,1.33C411.24,351.27,411.78,351.53,412.43,351.74Zm.32.76-.48,2.39c1.05-.05,1.75-.51,1.75-1.3C414,353,413.43,352.71,412.75,352.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_507",
    "data-name": "Trazado 507",
    d: "M397.9,426.39c-.14,0-.26-8.93-.26-19.95s.12-19.95.26-19.95.26,8.93.26,19.95S398,426.39,397.9,426.39Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_508",
    "data-name": "Trazado 508",
    d: "M281.27,429.51c0,.15-10.91.26-24.36.26s-24.36-.11-24.36-.26,10.91-.26,24.36-.26S281.27,429.37,281.27,429.51Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Counter--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_509",
    "data-name": "Trazado 509",
    d: "M715.4,462.59c0,.15-148.33.26-331.26.26s-331.29-.11-331.29-.26,148.29-.26,331.29-.26S715.4,462.45,715.4,462.59Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_510",
    "data-name": "Trazado 510",
    d: "M240.52,197,251,178.5a49.59,49.59,0,1,1,11.88,13.22h0Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_511",
    "data-name": "Trazado 511",
    d: "M240.52,197l22.38-5.4-.07.2h0l-.6-.78.78.6a51.089,51.089,0,0,0,10.16,6,49.439,49.439,0,0,0,13.5,3.8,44.18,44.18,0,0,0,7.78.37c1.33-.08,2.7-.12,4.07-.24l4.15-.64a49.56,49.56,0,0,0,30.62-19.74,48.84,48.84,0,0,0,8.26-18.94,50.11,50.11,0,0,0-.59-21.8,48.34,48.34,0,0,0-10.51-20.14l-2-2.2a26.941,26.941,0,0,0-2.15-2,24.275,24.275,0,0,0-2.22-1.94l-2.35-1.75a18.7,18.7,0,0,0-2.44-1.61l-2.48-1.51-2.6-1.27a22.882,22.882,0,0,0-2.63-1.17,50,50,0,0,0-22-3.39,48.43,48.43,0,0,0-20.17,5.94A49.94,49.94,0,0,0,246.08,138a53.61,53.61,0,0,0-2.18,16,49.341,49.341,0,0,0,2.35,13.82,50.411,50.411,0,0,0,4.89,10.62v.13C244.33,190.4,241,196.25,240.52,197l10.4-18.58v.13a50.33,50.33,0,0,1-5-10.66,49.38,49.38,0,0,1-2.42-13.9,53.52,53.52,0,0,1,2.16-16.11A50.23,50.23,0,0,1,269.2,109a48.82,48.82,0,0,1,20.37-6,50.62,50.62,0,0,1,22.19,3.41,26.077,26.077,0,0,1,2.65,1.18l2.63,1.28,2.51,1.53A20.873,20.873,0,0,1,322,112l2.37,1.78a27.935,27.935,0,0,1,2.25,2c.72.68,1.51,1.3,2.18,2l2,2.22a48.94,48.94,0,0,1,10.61,20.36,50.49,50.49,0,0,1,.58,22,49.22,49.22,0,0,1-8.36,19.12,50,50,0,0,1-30.93,19.87l-4.19.63c-1.38.12-2.76.15-4.1.23a44.819,44.819,0,0,1-7.84-.4A49.82,49.82,0,0,1,273,198a50.91,50.91,0,0,1-10.19-6.14l.19-.18h0l.12.17h-.19Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_512",
    "data-name": "Trazado 512",
    d: "M276.69,153.28l5.01-5.01,9.66,8.59,18.97-18.25,4.65,5.01-24.33,22.9Z",
    fill: "#2650ae"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPaymentPana);
export default __webpack_public_path__ + "static/media/Cash_Payment_pana.d52a4540ca1ee927a5ab51db2c2c5af2.svg";
export { ForwardRef as ReactComponent };